import { useState } from 'react';

const PADAB010 = ({ userData, updateUserData, onNext, statusIntegrated }) => {
    const [activeTerms, setActiveTerms] = useState({
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
    });

    const toggleTermsContent = (index) => {
        setActiveTerms((prevState) => ({
            [index]: !prevState[index],
        }));
    };

    const [checkboxes, setCheckboxes] = useState({
        'accept-all': false,
        'accept-1': false,
        'accept-2': false,
        'accept-3': false,
        'accept-4': false,
        'accept-5': false,
    });

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        if (name === 'accept-all') {
            const updatedCheckboxes = {};
            for (let key in checkboxes) {
                updatedCheckboxes[key] = checked;
            }
            setCheckboxes(updatedCheckboxes);
        } else {
            setCheckboxes((prev) => {
                const nextState = {
                    ...prev,
                    [name]: checked,
                };
                const individualKeys = Object.keys(nextState).filter((key) => key !== 'accept-all');
                const allIndividualChecked = individualKeys.every((key) => nextState[key] === true);
                nextState['accept-all'] = allIndividualChecked;
                return nextState;
            });
        }
    };

    const handleSubmit = (memberGbn) => {
        if (!checkboxes['accept-1']) {
            window.alert('(필수) 이용약관 - 덴탈잡 동의해 주세요.');
            return;
        } else if (!checkboxes['accept-2']) {
            window.alert('(필수) 이용약관 - 덴탈비타민, 덴탈세미나 동의해 주세요.');
            return;
        } else if (!checkboxes['accept-3']) {
            window.alert('(필수) 이용약관 - DVmall 동의해 주세요.');
            return;
        } else if (!checkboxes['accept-4']) {
            window.alert('(필수) 개인정보 수집 및 이용에 동의해 주세요.');
            return;
        }
        updateUserData({ memberGbn });
        onNext();
    };

    return (
        <div className="register-container">
            {/* Content Register */}
            <div id="terms-and-conditions" className="content-wrap">
                <div className="tabs-content ver2">
                    <div id="member-dentail" className="tab-content-item pd50 active">
                        <ul>
                            <li>
                                <div className="title-terms">
                                    <label className="reg__label">
                                        <input
                                            type="checkbox"
                                            name="accept-all"
                                            defaultValue="accept-all"
                                            className="reg__checkbox"
                                            id="accept-all"
                                            checked={checkboxes['accept-all']}
                                            onChange={handleCheckboxChange}
                                        />
                                    </label>
                                    <div className="flex">
                                        <h1>
                                            이용약관, 개인정보 수집 및 이용, 이벤트 등 프로모션 안내정보 수신(선택)에
                                            모두 동의합니다.
                                        </h1>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="title-terms">
                                    <label className="reg__label">
                                        <input
                                            type="checkbox"
                                            name="accept-1"
                                            defaultValue="accept"
                                            className="reg__checkbox"
                                            checked={checkboxes['accept-1']}
                                            onChange={handleCheckboxChange}
                                        />
                                    </label>
                                    <p>
                                        <span className="flex">
                                            <span>이용약관동의 - 덴탈잡</span>
                                        </span>
                                        <strong>(필수)</strong>
                                        <span className="view-more-btn" onClick={() => toggleTermsContent(0)}>
                                            <span className="star">※</span>
                                            <span>이용약관 전문보기</span>
                                        </span>
                                    </p>
                                </div>
                                <div className={`content-terms ${activeTerms[0] ? 'active' : ''}`}>
                                    <div className="contracts">
                                        <p className="mar_b10">
                                            <strong>제 1 조 (목적)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            본 약관은 주식회사 신흥(이하 "회사")이 제공하는 웹사이트(이하 "사이트")를
                                            통해 인터넷 관련 서비스(이하 "서비스")를 제공함에 있어, 사이트가 제공하는
                                            서비스와 관련하여, 이를 이용하는 이용자(이하 "회원")의 이용조건 및 제반
                                            절차, 기타 필요한 사항을 규정함을 목적으로 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 2 조 (용어의 정의)</strong>
                                        </p>
                                        <p className="mar_b5">이 약관에서 사용하는 용어의 정의는 아래와 같다.</p>
                                        <p className="mar_b5">
                                            ① "사이트"라 함은 서비스를 이용자에게 제공하기 위하여 컴퓨터 등
                                            정보통신설비를 이용하여 설정한 가상의 영업장 또는 웹사이트, 모바일웹, 앱
                                            등의 서비스를 제공하는 모든 매체를 말하며, 통합된 하나의 아이디 및
                                            비밀번호(이하 "통합계정")를 이용하여 "서비스" 를 제공받을 수 있는 아래의
                                            "사이트"로 정의한다.
                                        </p>
                                        <p>- 구인구직정보제공 : www.dentaljob.co.kr</p>
                                        <p>- 온라인정보제공 : www.dentalvitamin.com, www.dentalseminar.co.kr</p>
                                        <p>- 전자상거래(상품주문, 세미나신청) : www.dvmall.co.kr</p>
                                        <p className="mar_b5">
                                            ② "서비스"란 사이트를 통해 개인 또는 기업, 단체가 구직 또는 구인을 목적으로
                                            제공하는 자료를 DB화하여 각각의 목적에 맞게 자료를 가공, 집계하여 정보를
                                            제공하는 서비스와 취업 및 채용에 관련된 부가정보 서비스, 온라인 구매와
                                            세미나 및 이벤트, 프로모션 등의 정보제공을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "회원"이라 함은 서비스를 이용하기 위하여 동 약관에 동의하고 "사이트"와
                                            이용계약을 체결하여 이용자ID를 부여받은 개인을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "개인회원"이라 함은 구직을 목적으로 하는 개인이 본 서비스를 이용하기
                                            위하여 동 약관에 동의하고 "사이트"와 이용계약을 체결하여 이용자ID를 부여받은
                                            "회원"을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "치과회원"이라 함은 자사의 직접 고용의 목적으로 채용을 원하는 병의원
                                            단체(이하 "업체")나 구인을 목적으로 하는 개인이 본 서비스를 이용하기 위하여
                                            동 약관에 동의하고 "사이트"와 이용계약을 체결하여 이용자ID를 부여받은
                                            "회원"을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ "비회원"이라 함은 회원가입 절차를 거치지 않고 "사이트"가 제공하는 서비스를
                                            이용하거나 하려는 자를 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ "이용자"란 "사이트"가 제공하는 서비스를 받는 회원 및 비회원을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑧ "이용자ID" 또는 "회원ID"라 함은 "회원"의 식별과 "회원"의 "서비스" 이용을
                                            위하여 "회원"이 선정하고 "사이트"가 부여하는 문자와 숫자의 조합을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑨ "비밀번호"라 함은 "사이트"의 "서비스"를 이용하려는 사람이 "이용자ID"를
                                            부여받은 자와 동일인임을 확인하고 회원의 권익을 보호하기 위하여 회원이
                                            선정한 문자와 숫자의 조합을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑩ "세미나 참가비"라 함은 "사이트"에서 제공하는 세미나에 참석하는 대가로
                                            회사가 별도로 정한 요금체계에 의해 부과되는 비용을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑪ "주문"이라 함은 "사이트"에서 제공하는 서비스를 이용하기 위해 컨텐츠,
                                            재화등을 신청하는 것을 말한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 3 조 (약관의 명시와 개정)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 이 약관의 내용과 상호, 영업소 소재지, 대표자의 성명,
                                            사업자등록번호, 연락처 등을 이용자가 알 수 있도록 초기 화면에 게시하거나
                                            기타의 방법으로 이용자에게 공지해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 약관의 규제에 관한 법률, 전자거래기본법, 전자서명법,
                                            전기통신기본법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호,
                                            전자상거래등에서의 소비자보호에 관한법률 등에 관한 법률 등 관련법을 위배하지
                                            않는 범위에서 약관을 개정할 수 있으며, 변경된 약관은 "사이트" 화면에
                                            게시되거나 기타의 방법으로 "회원"에게 공지됨으로써 효력이 발생한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"가 약관을 개정할 경우 적용일자 및 개정사유를 명시하여 현행약관과
                                            함께 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지한다. 단
                                            "회원"의 권리, 의무에 중대한 영향을 주는 변경의 경우에는 적용일자 30일
                                            전부터 공지하도록 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "회원"는 변경된 약관에 대해 거부할 권리가 있다. "회원"는 변경된 약관이
                                            공지된 지 15일 이내에 거부 의사를 표명할 수 있다. "회원"가 거부하는 경우 본
                                            "서비스" 제공자인 "사이트"는 15일의 기간을 정하여 "회원"에게 사전 통지 후
                                            당해 "회원"와의 계약을 해지할 수 있다. 만약, "회원"가 거부 의사를 표시하지
                                            않고 "서비스"를 계속 이용하는 경우에는 동의하는 것으로 간주한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 4조 (약관의 해석)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 이 약관에서 규정하지 않은 사항에 관해서는 약관의 규제 등에 관한 법률,
                                            전기통신기본법, 전기통신사업법, 정보통신망이용촉진등에관한법률 등의
                                            관계법령에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 각 사이트 및 서비스 이용약관이 있는 경우에는 서비스 이용약관이 우선한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "회원"이 "사이트"와 개별 계약을 체결하여 서비스를 이용할 경우에는 개별
                                            계약이 우선한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 5 조 (이용계약의 성립)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"의 서비스 이용계약(이하 '이용계약'이라 한다)은 서비스를 이용하고자
                                            하는 자의 본 약관과 개인정보보호정책의 내용에 대한 동의 및
                                            이용신청(회원가입신청)에 대하여 "사이트"가 승낙함으로써 성립한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 서비스를 이용하고자 하는 자가 이용신청 당시 웹상의 "동의함" 버튼을 누르면
                                            본 약관 및 개인정보보호정책에 대하여 동의한 것으로 간주한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 특히 치과회원으로 가입하고자 하는 치과병의원, 기공소, 종합병원등은 국내외
                                            사업자등록증을 보유하고 있는 업체에 한해 회원 가입을 허락한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 제1항의 승낙은 이용신청자의 본 약관에 대한 동의를 확인하고 웹 상의 안내
                                            또는 전자메일로 통지함으로써 이루어지고 이러한 승낙의 통지가 이용신청자에게
                                            도달하면 이용계약이 성립한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 구인구직정보제공 사이트의 인재정보에 개인회원이 구직활동을 위해 공개한
                                            이력서정보는 열람권한을 가진 치과회원에게 제공된다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 6 조 (서비스 이용신청)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회원으로 가입하여 본 서비스를 이용하고자 하는 이용자는 "사이트"에서
                                            요청하는 제반정보(업체명, 사업자등록번호, 대표자 이름, 가입자 이름,
                                            생년월일, 전화번호, 휴대폰번호 등)를 제공하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 실명으로 등록하지 않은 사용자는 일체의 권리를 주장할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 모든 치과회원은 반드시 업체명과 사업자등록번호를 제공하여야만 서비스를
                                            이용할 수 있다. 업체명과 사업자등록번호를 허위로 등록한 경우, 휴·폐업
                                            사업자등록번호로 등록한 경우에 사용자는 일체의 권리를 주장할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 타인의 명의를 도용하여 이용신청을 한 회원의 모든 ID는 삭제되며, 관계법령에
                                            따라 처벌을 받을 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 사업자등록번호가 없는 업체, 기관이나 단체는 "사이트"가 정한 별도의 절차에
                                            따라 이용신청을 할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 회원으로 가입하더라도 로그인하지 않은 상태에서 주문하는 경우는 회원주문이
                                            아니라 비회원주문으로 인정한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 7 조 (이용신청의 승낙과 제한)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 전조의 규정에 의한 이용신청 고객에 대하여 업무수행상 또는
                                            기술상 지장이 없는 경우에는 원칙적으로 접수순서에 따라 서비스 이용을
                                            승낙한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 아래 사항에 해당하는 경우에 대해서는 이용신청을 승낙하지
                                            아니한다.
                                        </p>
                                        <p>
                                            1. 실제 업체명과 사업자등록번호가 아니거나 타사의 정보를 이용하여 신청한
                                            경우
                                        </p>
                                        <p>
                                            2. 이용계약 신청서의 내용을 허위로 기재하거나 "사이트"가 제시하는 내용을
                                            기재하지 않은 경우
                                        </p>
                                        <p>3. 본인의 생년월일이 아닌 경우</p>
                                        <p>4. 사회의 안녕 질서 또는 미풍양속을 저해할 목적으로 신청한 경우</p>
                                        <p>5. "사이트" 회원들의 보편적인 정서에 반하는 물의를 일으킨 경우</p>
                                        <p>6. "사이트"가 정한 기타 이용신청 요건에 맞지 않을 경우</p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 아래 사항에 해당하는 경우에는 그 신청에 대하여 승낙제한 사유가
                                            해소될 때까지 승낙을 유보할 수 있다.
                                        </p>
                                        <p>1. "사이트"가 설비의 여유가 없는 경우</p>
                                        <p>2. "사이트"의 기술상 지장이 있는 경우</p>
                                        <p>3. 기타 "사이트"의 귀책사유로 이용승낙이 곤란한 경우</p>
                                        <p className="mar_b5">
                                            ④ "회원"은 기재한 등록사항에 변경이 있는 경우, 즉시 전자우편 등 기타
                                            방법으로 그 변경 사항을 수정해야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 8 조 (서비스의 제공 및 변경)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 제2조 2항의 서비스를 제공할 수 있으며 그 내용은 다음 각 호와
                                            같습니다.
                                        </p>
                                        <p>1. 구인구직정보제공</p>
                                        <p>- 온라인 입사지원 서비스</p>
                                        <p>- 채용정보 등록서비스</p>
                                        <p>- 구인/구직과 관련된 제반 서비스</p>
                                        <p>- 이력서 열람 서비스</p>
                                        <p>2. 온라인정보제공</p>
                                        <p>- 뉴스레터 이메일 서비스</p>
                                        <p>- 상품 및 제품등의 프로모션 및 이벤트에 관련된 서비스</p>
                                        <p>3. 전자상거래</p>
                                        <p>- 재화등에 대한 정보 제공 및 구매계약의 체결</p>
                                        <p>- 구매계약이 체결된 재화등의 배송</p>
                                        <p>- 세미나등에 대한 정보 제공 및 신청계약의 체결</p>
                                        <p>- 신청계약이 체결된 세미나등의 제공</p>
                                        <p>4. 이용자간의 교류와 소통과 관련된 서비스</p>
                                        <p>5. 자료 거래에 관련된 서비스</p>
                                        <p>
                                            6. 기타 "사이트"가 추가 개발하거나 제휴계약 등을 통해 "회원"에게 제공하는
                                            일체의 서비스
                                        </p>
                                        <p>7. 기타 "사이트"에서 정하는 업무 및 일체의 서비스</p>
                                        <p className="mar_b5">
                                            ② "사이트"는 필요한 경우 서비스의 내용을 추가 또는 변경할 수 있다. 단, 이
                                            경우 "사이트"는 추가 또는 변경내용을 회원에게 공지해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 재화등의 품절 또는 기술적 사양의 변경 등의 경우에는 장차
                                            체결되는 계약에 의해 제공할 재화등의 내용을 변경할 수 있다. 이 경우에는
                                            변경된 재화등의 내용 및 제공일자를 명시하여 현재의 재화등의 내용을 게시한
                                            곳에 즉시 공지한다. 단, 사이트가 합리적으로 예측할 수 없는 불가피한 여건이나
                                            사정이 있는 경우, 위 공지를 하지 않을 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화등의 품절
                                            또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게
                                            통지 가능한 주소로 즉시 통지한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 9 조 (치과회원 정보, 채용공고 등록과 이력서 검색)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 치과회원은 구직을 원하는 개인회원이 채용공고를 열람한 후 해당 기업에 대한
                                            판단을 돕기 위해 기업정보를 정확히 기재하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 치과회원은 직업안정법 제34조 및 동법 시행령 제34조 거짓 구인공고의 범위에
                                            위배되지 않도록 채용공고를 작성하여 등록해야 하며 그 내용은 다음과 같다.
                                        </p>
                                        <p>
                                            1. 구인을 가장하여 물품판매, 수강생 모집, 직업소개, 부업알선, 자금모집 등을
                                            행하는 광고
                                        </p>
                                        <p>
                                            2. 허위 구인을 목적으로 구인자의 신원(업체명 또는 성명)을 표시하지 아니하는
                                            광고
                                        </p>
                                        <p>
                                            3. 구인자가 제시한 직종, 고용형태, 근로조건 등이 응모할 때의 그것과 현저히
                                            다른 광고
                                        </p>
                                        <p>4. 기타 광고의 중요내용이 사실과 다른 광고</p>
                                        <p>5. 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</p>
                                        <p>6. 공공질서 및 미풍양속에 위반되는 내용인 경우</p>
                                        <p>
                                            7. 현행법에 위배되는 내용이나 범죄적 행위에 결부된다고 인정되는 내용일 경우
                                        </p>
                                        <p>
                                            8. 사이트의 저작권 또는 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
                                        </p>
                                        <p>9. 게시판의 성격에 부합하지 않는 게시물의 경우</p>
                                        <p>
                                            10. 기타 관계 법규에 위배되는 내용이나, 사이트의 원활한 운영을 위하여
                                            운영자가 필요하다고 판단한 경우
                                        </p>
                                        <p className="mar_b5">
                                            ③ 치과회원은 남녀 고용 평등과 일, 가정 양립 지원에 관한 법률 제7조 및 관련
                                            법률에 의거하여 근로자의 모집 및 채용에 있어서 남녀, 연령을 차별하여서는
                                            아니되며 15세 미만 채용 모집을 할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 제2항, 제3항을 위반한 경우 이에 대한 책임은 전적으로 치과회원에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 치과회원이 등록한 정보 및 채용공고를 "사이트"가 정한 방법에
                                            의해 노출할 수 있으며, "사이트"가 지정한 기간이 지난 채용공고는 "사이트"가
                                            임의로 마감시킬 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 치과회원은 직원 채용의 목적으로 유·무료로 개인회원이 등록한 이력서를
                                            검색할 수 있으며 치과회원은 "사이트"가 제시하는 별도의 커뮤니케이션을 통하여
                                            개인회원에게 연락을 취할 수 있다. 단, 이력서 연락처의 열람 및 연락의 목적은
                                            직원 채용활동에 국한되어야 하며, 기업의 영업ㆍ마케팅ㆍ제3자 제공 시에는
                                            개인정보보호법, 직업안정법, 정보통신망 이용 촉진 및 정보 보호 등에 관한
                                            법률에 의거하여 법적 책임을 질 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ "사이트"는 "기업회원"이 이력서를 검색하고, "개인회원"에게 연락할 수 있는
                                            권한에 제한을 둘 수 있으며, "기업회원"이 적절하지 않은 방법으로
                                            "개인회원"에게 연락하거나, "개인회원"에게 불편을 끼친 경우, 채용공고 및
                                            회원정보를 임의로 수정/삭제할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑧ 치과회원이 자사의 직접 고용을 목적으로 하지 않는 공고를 등록할 경우
                                            "사이트"는 해당 공고를 삭제할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑨ 채용광고의 근무처 및 근무지역은 치과회원이 위치한 지역 및 근무처에 한해야
                                            한다. 본사에 지사, 지점, 영업소등을 포함하고 있는 경우는 개별 지사, 지점,
                                            영업소 단위로 채용광고를 해야 하며, 본사를 통한 일괄적인 채용광고는 할 수
                                            없다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 10 조 (개인회원 정보, 이력서 노출)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "개인회원"의 이력서는 개인이 회원가입 또는 이력서 작성 및 수정시 희망한
                                            형태로 이력서를 노출한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 개인회원이 회원정보, 이력서의 공개/비공개 지정, 이력서상의
                                            연락처 공개/비공개를 자유롭게 선택할 수 있도록 하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 개인회원이 이력서 공개를 희망했을 경우, 치과회원의 이력서
                                            열람에 동의한것으로 간주하며, "사이트"는 이들 회원에게 무료/유료로 이력서
                                            열람 서비스를 제공할 수 있다. 다만, 연락처 등 각 항목이 비공개로 지정된 경우
                                            해당 항목별 연락처를 노출할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 사이트는 개인회원이 등록한 이력서를 아이디 휴면상태 이전까지 노출할 수
                                            있으며, 사이트가 지정한 기간이 지난 이력서는 개인회원 탈퇴시 까지 관리할 수
                                            있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 안정적인 서비스를 제공하기 위해 테스트 및 모니터링 용도로
                                            "사이트" 운영자가 이력서 정보를 열람하도록 할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 11 조 (서비스의 요금)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회원 가입은 무료이며, 채용광고등록은 유료로 운영된다. 또한 개인회원 또는
                                            사이트에 방문한 회원에게 자신의 정보를 보다 효과적으로 노출시키기 위한
                                            추가적인 유료 서비스를 제공한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 유료서비스를 제공할 경우 사이트에 요금에 대해서 공지를 하여야
                                            한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 유료서비스 이용금액을 서비스의 종류 및 기간에 따라 "사이트"가
                                            예고 없이 변경할 수 있다. 다만, 변경 이전에 적용 또는 계약한 금액은 소급하여
                                            적용하지 아니한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 유료 서비스 신청 후 "회원" 사정에 의해 서비스가 취소될 경우, 정부가
                                            고시하는 '디지털콘텐츠 이용자보호지침'에 따라 "사이트"는 본 지침이 제시하는
                                            범위 내에서 환불 수수료를 부과할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 12 조 (서비스 이용시간)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 특별한 사유가 없는 한 연중무휴, 1일 24시간 서비스를 제공한다.
                                            다만, "사이트"는 서비스의 종류나 성질에 따라 제공하는 서비스 중 일부에
                                            대해서는 별도로 이용시간을 정할 수 있으며, 이 경우 "사이트"는 그 이용시간을
                                            사전에 회원에게 공지 또는 통지하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 자료의 가공과 갱신을 위한 시스템 작업시간, 장애해결을 위한
                                            보수작업 시간, 정기 PM작업, 시스템 교체작업, 회선 장애 등이 발생한 경우
                                            일시적으로 서비스를 중단할 수 있으며 계획된 작업의 경우 공지란에 서비스 중단
                                            시간과 작업 내용을 알려야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 13 조 (서비스 제공의 중지)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 다음 각 호에 해당하는 경우 서비스의 제공을 중지할 수 있다.
                                        </p>
                                        <p>1. 설비의 보수 등 "사이트"의 필요에 의해 사전에 회원들에게 통지한 경우</p>
                                        <p>2. 기간통신사업자가 전기통신서비스 제공을 중지하는 경우</p>
                                        <p>3. 기타 불가항력적인 사유에 의해 서비스 제공이 객관적으로 불가능한 경우</p>
                                        <p className="mar_b5">
                                            ② 전항의 경우, "사이트"는 기간의 정함이 있는 유료서비스 이용자들에게는 그
                                            이용기간을 연장하는 등의 방법으로 손실을 보상하여야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 14 조 (정보의 제공 및 광고의 게재)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 회원에게 서비스 이용에 필요가 있다고 인정되거나 서비스 개선 및
                                            회원대상의 서비스 소개 등의 목적으로 하는 각종 정보에 대해서 전자우편이나
                                            서신우편을 이용한 방법으로 제공할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 제공하는 서비스와 관련되는 정보 또는 광고를 서비스 화면,
                                            홈페이지 등에 게재할 수 있으며, 회원들에게 메일을 통해 알릴 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 서비스상에 게재되어 있거나 본 서비스를 통한 광고주의 판촉활동에
                                            회원이 참여하거나 교신 또는 거래를 함으로써 발생하는 모든 손실과 손해에 대해
                                            책임을 지지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 본 서비스의 회원은 서비스 이용 시 노출되는 광고게재에 대해 동의 하는
                                            것으로 간주한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 15 조 (자료내용의 책임과 "사이트"의 정보 수정 권한)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 자료내용은 회원이 등록한 업체정보, 채용공고, 이력서정보 및 사이트에 게시한
                                            게시물을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회원은 자료 내용 및 게시물을 사실에 근거하여 성실하게 작성해야 하며, 만일
                                            자료의 내용이 사실이 아니거나 부정확하게 작성되어 발생하는 모든 책임은
                                            회원에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 모든 자료내용의 관리와 작성은 회원 본인이 하는 것이 원칙이나 사정상 위탁
                                            또는 대행관리를 하더라도 자료내용의 책임은 회원에게 있으며 회원은 주기적으로
                                            자신의 자료를 확인하여 항상 정확하게 관리가 되도록 노력해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 회원이 등록한 자료 내용에 오자, 탈자 또는 사회적 통념에
                                            어긋나는 문구와 내용이 있을 경우 이를 언제든지 수정할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 "회원"이 등록한 자료를 "사이트"가 운영하는 같은 목적의 타
                                            "사이트"에도 게재할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ "회원"이 등록한 자료로 인하여 타인(또는 타법인)으로부터 허위사실 및
                                            명예훼손 등으로 삭제요청이 접수된 경우 "사이트"는 "회원"에게 사전 통지 없이
                                            본 자료를 삭제할 수 있으며, 자료 삭제후 메일 등의 방법으로 "회원"에게 통지할
                                            수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ "사이트"는 다음 각 호에 해당하는 경우 회원의 동의를 받아 회원이 신청한
                                            정보를 변경할 수 있다.
                                        </p>
                                        <p>
                                            - 아이디가 회원의 전화번호, 생년월일 등으로 등록되어 있어서 회원의 사생활을
                                            침해할 우려가 있는 경우
                                        </p>
                                        <p>- 고객센터문의, 이메일 등의 방법을 통해 변경요청하는 경우</p>
                                        <p>- 기타 "사이트"의 기술상 현저히 지장이 있다고 판단되는 경우</p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 16 조 (회사의 의무)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회사는 본 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 수
                                            있도록 최선의 노력을 다해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회사는 서비스와 관련한 회원의 불만사항이 접수되는 경우 이를 즉시
                                            처리하여야 하며, 즉시 처리가 곤란한 경우에는 그 사유와 처리일정을 서비스
                                            화면 또는 기타 방법을 통해 동 회원에게 통지하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 회사는 유료 결제와 관련한 결제 사항 정보를 1년 이상 보존한다. 다만 회원
                                            자격이 없는 회원은 예외로 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 천재지변 등 예측하지 못한 일이 발생하거나 시스템의 장애가 발생하여
                                            서비스가 중단될 경우 이에 대한 손해에 대해서는 회사가 책임을 지지 않는다.
                                            다만 자료의 복구나 정상적인 서비스 지원이 되도록 최선을 다할 의무를 진다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 회원의 자료를 본 서비스 이외의 목적으로 제3자에게 제공하거나 열람시킬 경우
                                            반드시 회원의 동의를 얻어야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 치과회원이 사이트에 등록한 치과정보, 채용공고 내용은 사이트를 방문하는
                                            일반 대중에게 공개함을 원칙으로 하며 회사는 공개 기간을 지정할 수 있다. 단,
                                            일부 비공개 항목은 회사에서 제시하는 별도의 옵션을 통해 지정할 수 있으며,
                                            회사는 이 항목에 대한 비공개 의무를 진다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ 구직자의 정보의 정확성은 구인자가 직접 확인하여야 하며 회사는 이와
                                            관련하여 어떠한 책임도 지지 아니한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 17 조 (회원의 의무)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회원은 관계법령과 본 약관의 규정 및 기타 "사이트"가 통지하는 사항을
                                            준수하여야 하며, 기타 "사이트"의 업무에 방해되는 행위를 해서는 안된다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회원이 신청한 유료서비스는 등록 또는 신청과 동시에 "사이트"와 채권, 채무
                                            관계가 발생하며, 회원은 이에 대한 요금을 지정한 기일 내에 납부하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 회원이 결제 수단으로 신용카드를 사용할 경우 비밀번호 등 정보 유실 방지는
                                            회원 스스로 관리해야 한다. 단, 사이트의 결함에 따른 정보유실의 발생에 대한
                                            책임은 회원의 의무에 해당하지 아니한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 회원은 서비스를 이용하여 얻은 정보를 "사이트"의 사전동의 없이 복사, 복제,
                                            번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 회원은 본 서비스를 건전한 직원채용 이외의 목적으로 목적으로 사용해서는
                                            안되며 이용 중 다음 각 호의행위를 해서는 안된다.
                                        </p>
                                        <p>1. 다른 회원의 아이디를 부정 사용하는 행위</p>
                                        <p>2. 범죄행위을 목적으로 하거나 기타 범죄행위와 관련된 행위</p>
                                        <p>3. 타인의 명예를 훼손하거나 모욕하는 행위</p>
                                        <p>4. 타인의 지적재산권 등의 권리를 침해하는 행위</p>
                                        <p>5. 해킹행위 또는 바이러스의 유포 행위</p>
                                        <p>
                                            6. 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 계속적으로 전송하는
                                            행위
                                        </p>
                                        <p>7. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있다고 판단되는 행위</p>
                                        <p>8. 사이트의 정보 및 서비스를 이용한 영리 행위</p>
                                        <p>9. 그밖에 선량한 풍속, 기타 사회질서를 해하거나 관계법령에 위반하는 행위</p>
                                        <p className="mar_b5">
                                            ⑥ 치과회원은 "사이트"를 통해 열람한 이력서 정보를 "사이트" 및 당사자의
                                            허락없이 재배포할 수 없으며 본 정보에 대한 출력 및 복사 등의 관리 책임은
                                            전적으로 치과회원에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ 아이디(ID)와 비밀번호의 관리에 대한 책임은 "회원"에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑧ "회원"은 자신의 아이디(ID)를 타인에게 양도, 증여할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑨ 자신의 아이디(ID)가 부정하게 사용된 경우, "회원"은 반드시 "사이트"에 그
                                            사실을 통보해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑩ "회원"은 본 "사이트"에 규정한 제반 준수 사항을 바탕으로 회원의 신용을
                                            평가받게 된다.
                                        </p>
                                        <p className="mar_b5">⑪ 자료 공개 방식은 스스로 결정해서 관리한다.</p>
                                        <p className="mar_b5">
                                            ⑫ "회원"은 자신의 비밀번호를 분실한 경우 임시비밀번호를 발급받아 새로운
                                            비밀번호로 변경해야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 18 조 (회원의 가입해지/서비스중지/자료삭제)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "회원"은 언제든지 회원탈퇴 또는 채용공고 등록을 해지하기 위해 고객센터
                                            또는 회원탈퇴 메뉴 등을 통하여 이용계약 해지 신청을 할 수 있으며,
                                            가입해지시는 해지사유를 밝혀야 한다. 또한 "사이트"는 관련법 등이 정하는 바에
                                            따라 이를 처리해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 다음의 사항에 해당하는 경우 "사이트"는 사전 동의없이 가입해지나 서비스
                                            중지, 채용공고 삭제 조치를 취할 수 있다.
                                        </p>
                                        <p>1. 회원의 의무를 성실하게 이행하지 않았을 때</p>
                                        <p>2. 규정한 유료서비스 이용 요금을 납부하지 않았을 때</p>
                                        <p>3. 불순한 의도로 유료서비스를 반복적으로 결제/취소할 때</p>
                                        <p>
                                            4. 본 서비스 목적에 맞지 않는 분야에 정보를 활용하여 사회적 물의가 발생한 때
                                        </p>
                                        <p>5. 회원이 등록한 정보의 내용이 사실과 다르거나 조작되었을 때</p>
                                        <p>6. 사업자등록증에 나타난 정보와 기업회원 가입시의 정보가 일치하지 않을 때</p>
                                        <p>
                                            7. 타 기업의 사업자등록번호나 상호를 도용하여 허위로 기업정보를 등록하거나
                                            휴·폐업 사업자등록번호로 기업정보를 등록했을 때
                                        </p>
                                        <p>
                                            8. 지사, 지점, 영업소 등의 경우 구체적인 지사, 지점, 영업소 명칭을 사용하지
                                            않고 기업명을 등록했거나 지사, 지점, 영업소의 사업자등록번호가 별도 있음에도
                                            불구하고 본사의 사업자등록번호로 기업회원 가입을 했을 때
                                        </p>
                                        <p>
                                            9. 사이트명, 담당자 성명, 사무실 연락처 등 구인업체의 중요 정보를 정확하게
                                            기입하지 않았을 때
                                        </p>
                                        <p>
                                            10. 치과회원 가입 또는 채용공고 등록시 본 서비스에서 안내하는 방법으로
                                            가입하지 않았거나 등록하지 않았을 때
                                        </p>
                                        <p>11. 동일 회원 ID로 게재 중인 동일 내용 채용공고를 중복 등록했을 때</p>
                                        <p>12. 동일 사업자가 특별한 이유 없이 중복 가입했을 때</p>
                                        <p>
                                            13. 동일 사업자가 마감일이 지나지 않은 사실상의 동일내용의 채용공고를 다수
                                            ID를 사용하여 중복등록 했을 때
                                        </p>
                                        <p>14. 허위 구인공고를 등록했을 때</p>
                                        <p>15. 작성자가 제시한 직종, 업무내용, 근로조건 등이 실제와 현저히 다를 때</p>
                                        <p>16. 채용공고의 모집요강만으로 업무에 대한 내용이 명확하지 않을 때</p>
                                        <p>17. 모집요강에 적합한 업직종 분류를 지정하지 않았을 때</p>
                                        <p>
                                            (특히, 교육기관이나 이벤트업체 또는 영업대행기관의 경우 영업, 마케팅,
                                            텔레마케팅, 상담인력을 모집하고자 할 경우 반드시 텔레마케팅 또는 고객상담,
                                            교육/강사/학원등 반드시 직접 관련되는 해당 업종, 직종분류만 지정해야 한다.)
                                        </p>
                                        <p>18. 다단계, 피라미드 식의 모집 내용을 등록했을 때</p>
                                        <p>
                                            19. 구인을 가장하여 유학알선, 물품판매, 자금 모금 등을 행하는 내용을
                                            등록했을 때
                                        </p>
                                        <p>20. 교육비, 수강료를 요구하는 수강생 모집광고, 학원 광고를 등록했을 때</p>
                                        <p>
                                            21. 회원모집 형태의 광고 또는 카드회원 모집(수당제 광고) 내용을 등록했을 때
                                        </p>
                                        <p>
                                            22. 추천인 모집 광고, 재택 쇼핑몰 분양 광고, 직업소개, 부업알선 광고를
                                            등록했을 때
                                        </p>
                                        <p>
                                            23. 취업수수료 등 취업 관련 비용을 필요로 하는 채용공고를 등록했을 때 (운송,
                                            물류, 지입, 인력용역 등)
                                        </p>
                                        <p>24. 불건전한 내용의 유흥업소 채용공고를 등록했을 때</p>
                                        <p>
                                            25. 구직자의 피해사례가 (채용공고를 통해 구직자가 입사 과정에서 피해가
                                            발생한 경우 또는 재직중 "치과회원"이 관계법령을 위반하여 피해가 발생한 경우
                                            등)가 접수된 채용공고
                                        </p>
                                        <p>26. 임금체불 사실이 접수되었거나 근로감독원에 진정서가 접수되어 있는 기업</p>
                                        <p>
                                            27. 사업자 모집, 프랜차이즈 모집, 점포개설, 창업 등 직원 채용이 아닌 공고를
                                            등록했을때
                                        </p>
                                        <p>
                                            28. 메일이나 문자메시지 수신자가 스팸으로 신고하거나 회원이 발송하는
                                            메시지가 불법 스팸임이 판명될 경우
                                        </p>
                                        <p>
                                            29. 방송통신위원회 또는 한국정보보호진흥원이 불법 스팸 전송 사실을 확인하여
                                            이용 정지를 요청하는 경우
                                        </p>
                                        <p>
                                            30. 미래창조과학부(거짓으로 표시된 전화번호로 인한 이용자 피해 예방에 관한)
                                            고시 제2015-32호 제10조 제1항에 따라 미래창조과학부 또는 중앙전파관리소,
                                            한국 인터넷진흥원(KISA)에서 번호 변작 등으로 판명되어 이용 정지를 요청한
                                            경우
                                        </p>
                                        <p>31. 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</p>
                                        <p>
                                            32. 사이트의 저작권 또는 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
                                        </p>
                                        <p>33. 게시판의 성격에 부합하지 않는 게시물의 경우</p>
                                        <p>34. 공공질서 및 미풍양속에 위반되는 내용인 경우</p>
                                        <p>35. 회원들의 보편적인 정서에 반하는 물의를 일으킨 경우</p>
                                        <p>
                                            36. 기타 관계법규에 위배되는 내용이거나 사이트의 원활한 운영을 위하여
                                            운영자가 필요하다고 판단한 경우
                                        </p>
                                        <p>
                                            37. 기타 본 서비스 명예를 훼손하였거나 사이트가 판단하기에 적합하지 않은
                                            목적으로 회원가입을 하였을 때
                                        </p>
                                        <p>
                                            38. "회원"으로 등록하는 것이 "사이트"의 기술상 현저히 지장이 있다고 판단되는
                                            경우
                                        </p>
                                        <p className="mar_b5">
                                            ③ 회원이 유료서비스를 이용하는 중 "사이트"의 책임에 의해 정상적인 서비스가
                                            제공되지 않을 경우 회원은 본 서비스의 해지를 요청할 수 있으며 "사이트"는
                                            기간의 정함이 있는 유료서비스의 경우에는 해지일까지 이용일수를 1일
                                            기준금액으로 계산하여 이용금액을 공제후 환급하고, 이용건수의 정함이 있는
                                            유료서비스의 경우에는 기 사용분을 1건 기준금액으로 계산하여 이용금액을
                                            공제후 환급하거나 기간연장등의 방법으로 보상합니다. 단, 허위·불량공고의 경우
                                            게재시 지불된 광고료는 일체 반환되지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 회원 가입이 해지된 경우 해당 회원 정보를 모두 삭제하여야 하며,
                                            상법, 전자상거래등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여
                                            보존할 필요가 있는 경우 관계법령에서 정한 일정한 기간 동안 회원정보를
                                            보관한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 1년이상 "회원"의 관리 없이 방치되고 있다고 판단되는 "회원"의
                                            자료는 임의로 삭제할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 개인정보보호를 위하여 "회원"이 선택한 개인정보 보유기간(1년) 동안
                                            "사이트"를 이용하지 않은 경우, "아이디"를 "휴면계정"으로 분리하여 해당
                                            계정의 이용을 중지할 수 있다. 이 경우 "사이트"는 "휴면계정 처리
                                            예정일"로부터 30일 이전에 해당사실을 전자메일, 서면, SMS 중 하나의 방법으로
                                            사전통지하며 "회원"이 직접 본인확인을 거쳐, 다시 "사이트" 이용 의사표시를 한
                                            경우에는 "사이트" 이용이 가능하다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 19 조 (허위 구인광고 경고)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            허위 구인광고로 인해 발생된 문제에 따른 법적인 책임은 모두 작성자에게
                                            있으며, 구인광고 게재시에 지불된 광고료는 일체 반환되지 않습니다. 허위
                                            구인광고 또는 허위 구인 조건을 제시한 자는 직업 안정법 제 47조에 의해 5년
                                            이하의 징역 또는 2천만원 이하의 벌금형을 받게 된다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 20 조 (손해배상)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"가 이 약관의 제8조, 제16조, 제18조 등의 규정에 위반한 행위로
                                            이용자에게 손해를 입히거나 기타 "사이트"가 제공하는 모든 서비스와 관련하여
                                            "사이트"의 책임 있는 사유로 인해 이용자에게 손해가 발생한 경우 "사이트"는 그
                                            손해를 배상하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회원이 이 약관의 제6조, 제17조, 제18조 등의 규정에 위반한 행위로 "사이트"
                                            및 제3자에게 손해를 입히거나 회원의 책임 있는 사유에 의해 "사이트" 및
                                            제3자에게 손해를 입힌 경우에는 회원은 그 손해를 배상하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 "서비스" 이용과 관련하여 "회원"에게 발생한 손해 가운데 "회원"의
                                            고의, 과실 및 "회원"의 귀책사유로 인한 "서비스" 이용의 장애 및 손해에
                                            대하여는 책임을 지지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 "회원"이 "서비스"를 이용하여 기대하는 수익을 얻지 못하거나
                                            상실한 것에 대하여 책임을 지지 않으며, "사이트"가 무료로 제공하는 "서비스"의
                                            이용과 관련하여 개인정보 처리방침에서 정하는 내용에 위반하지 않은 한 어떠한
                                            손해도 책임지지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할
                                            수 없는 경우 "서비스" 제공에 관한 책임이 면제된다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 21 조 (이용요금 오류의 조정)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            "사이트"는 이용요금과 관련하여 오류가 있는 경우에 이용자의 요청, 또는
                                            "사이트"의 사전 통지에 의하여 다음에 해당하는 조치를 취한다.
                                        </p>
                                        <p className="mar_b5">
                                            ① 과다납입한 요금에 대하여는 그 금액을 반환하거나 이용기간을 조정한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 요금을 반환받아야 할 이용자가 요금체납이 있는 경우에는 반환해야 할
                                            요금에서 이를 우선 공제하고 반환한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 과소청구액에 대해서는 익월에 합산청구한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 22 조 (회원의 개인정보보호)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            "사이트"는 이용자의 개인정보보호를 위하여 노력해야 한다. 이용자의
                                            개인정보보호에 관해서는 정보통신망이용촉진 및 정보보호 등에 관한 법률에
                                            따르고, 사이트에 "개인정보취급방침"을 고지한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 23조 (신용정보의 제공 활용 동의)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"가 회원가입과 관련하여 취득한 "회원"의 신용 정보를 타인에게
                                            제공하거나 활용하고자 할 때에는 신용 정보의 이용 및 보호에 관한 법률
                                            제32조의 규정에 따라 사전에 그 사유 및 해당기관 또는 업체명 등을 밝히고 해당
                                            "회원"의 동의를 얻어야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 본 "서비스"와 관련하여 "사이트"가 "회원"으로부터 신용 정보 이용 및 보호에
                                            관한 법률에 따라 타인에게 정보제공 활용에 동의를 얻은 경우 "회원"은
                                            "사이트"가 신용 정보 사업자 또는 신용 정보 집중기관에 정보를 제공하여
                                            "회원"의 신용을 판단하기 위한 자료로 활용하거나, 공공기관에서 정책자료로
                                            활용되도록 정보를 제공하는 데 동의한 것으로 간주한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 24 조 (분쟁의 해결)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"와 회원은 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여
                                            필요한 모든 노력을 하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 전항의 노력에도 불구하고, 동 분쟁에 관한 소송은 "사이트"의 주소지
                                            관할법원으로 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 25 조 (자료 내용의 활용 및 온라인 입사 지원 정보)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "치과회원"이 입력한 정보는 채용 및 고용동향 통계 자료로 활용될 수 있으며
                                            채용공고는 매체를 통해 언론에 배포될 수 있다. 단, 활용되는 정보 중 개인을
                                            식별할 수 있는 정보는 제외된다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 "사이트"의 온라인 입사 지원 시스템을 통해 지원한 "개인회원"이
                                            자신의 이력서 열람 여부 및 지원자 통계 자료를 "개인회원"에게 제공할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"가 작성한 게시물 또는 저작물에 대한 저작권 및 기타 지적 재산권은
                                            "사이트"에 귀속한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "회원"이 "사이트" 내에 게시한 게시물의 저작권은 "회원"에게 귀속된다. 단,
                                            "회원"은 자신이 창작, 등록한 게시물에 대해 무상의 비독점적 사용권을
                                            "사이트"에 부여하고, 이 사용권은 "사이트"가 "사이트"를 운영하는 동안 계속
                                            유효하며, "회원" 탈퇴한 후에도 이와 같다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 게시물에 대한 권리와 책임은 게시물을 게시한 "회원"에게 있으며, "사이트"는
                                            "회원"의 동의 없이 이를 "사이트"가 운영하는 "사이트" 이외에 영리적 목적으로
                                            사용할 수 없다. 단, 비영리적인 경우에는 해당되지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ "사이트"에서 정당한 절차를 거쳐 "치과회원"이 열람한 개인 "회원"의 이력서
                                            정보는 해당 업체의 인사 자료이며, 이에 대한 관리 권한은 해당 업체의 정책에
                                            따른다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 26 조 (전자상거래 사이트에서의 구매 및 이용신청)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "이용자"는 전자상거래 "사이트"상에서 다음 또는 이와 유사한 방법에 의하여
                                            구매를 신청하며, 전자상거래 "사이트"는 이용자가 구매신청을 함에 있어서
                                            다음의 각 내용을 알기 쉽게 제공하여야 한다. 단, 회원인 경우 제2호 내지
                                            제4호의 적용을 제외할 수 있다.
                                        </p>
                                        <p>1. 재화등의 검색 및 선택</p>
                                        <p>
                                            2. 성명, 주소, 연락처(전화번호/핸드폰/이메일), 배송정보(수취인, 주소,
                                            연락처) 등의 입력
                                        </p>
                                        <p>
                                            3. 약관내용, 청약철회권이 제한되는 서비스, 배송료,설치비 등의 비용부담과
                                            관련한 내용에 대한 확인
                                        </p>
                                        <p>
                                            4. 약관에 동의하고 위 3호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)
                                        </p>
                                        <p>
                                            5. 재화등의 구매신청 및 이에 관한 확인 또는 전자상거래 "사이트"의 확인에
                                            대한 동의
                                        </p>
                                        <p>6. 결제방법의 선택</p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 27 조 (전자상거래 사이트에서의 지급방법과 시기)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"에서 구매한 재화등에 대한 대금지급방법은 다음 각 호의
                                            방법중 가용한 방법으로 할 수 있다. 단, 전자상거래 "사이트"은 이용자의
                                            지급방법에 대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수
                                            없으며, 현재 서비스 중인 것으로만 한다.
                                        </p>
                                        <p>1. 폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체</p>
                                        <p>2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제</p>
                                        <p>3. 온라인무통장입금</p>
                                        <p>4. 전자화폐에 의한 결제</p>
                                        <p>
                                            5. 마일리지, 포인트 등 "사이트" 또는 전자상거래 "사이트"가 지급한 수단에
                                            의한 결제
                                        </p>
                                        <p>
                                            6. 전자상거래 "사이트"와 계약을 맺었거나 전자상거래 "사이트"가 인정한
                                            상품권에 의한 결제
                                        </p>
                                        <p>7. 기타 전자상거래 "사이트"에서 정하는 통상적인 방법의 대금결제 등</p>
                                        <p className="mar_b5">
                                            ② 전자상거래 "사이트"에서 구매한 재화등 온라인 구매에 대한 대금지급시기는 그
                                            신청일로부터 7일이내로 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 전자상거래 "사이트"에서 서비스하는 세미나 신청의 대금지급시기는 전자상거래
                                            "사이트"에서 정한 마감일까지로 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>
                                                제 28 조 (전자상거래 사이트에서의 수신확인통지,구매신청 변경 및 취소)
                                            </strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"는 이용자의 구매신청이 있는 경우 이용자에게
                                            수신확인통지를 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 수신확인통지를 받은 이용자는 의사표시의 불일치등이 있는 경우에는 수신확인
                                            통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 전자상거래
                                            "사이트"는 배송전에 이용자의 요청이 있는 경우에는 지체없이 그 요청에 따라
                                            처리하여야 한다. 다만 이미 대금을 지불한 경우에는 제29조의 청약철회 등에
                                            관한 규정에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 전자상거래 "사이트"에서 제공하는 세미나 서비스를 신청한 이용자 중 이미
                                            대금을 지불한 경우 제 15 조의 청약철회 등에 관한 규정에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 전자상거래 "사이트"은 이용자가 구매(주문)신청 후 제27조에 의한
                                            지급방법으로 그 신청일로부터 7일 이내 또는 전자상거래 "사이트"에서 정한
                                            마감일까지 상품(이용)대금에 대해 입금이 확인되지 않을 경우 전자상거래
                                            "사이트"는 별도 의사 표시 없이 구매계약을 해제하는 것으로 처리할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 29 조 (전자상거래 사이트에서의 청약철회 등)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"와 재화등의 구매에 관한 계약을 체결한 이용자는
                                            수신확인의 통지를 받은 날부터 7일 이내에는 청약의 철회를 할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 이용자는 재화등을 배송받은 경우 다음 각 호의 1에 해당하는 경우에는 반품 및
                                            교환등 청약철회를 할 수 없다.
                                        </p>
                                        <p>
                                            1. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우 (다만, 재화
                                            등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수
                                            있다.)
                                        </p>
                                        <p>
                                            2. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우
                                        </p>
                                        <p>
                                            3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화등의 가치가 현저히 감소한
                                            경우
                                        </p>
                                        <p>
                                            4. 같은 성능을 지닌 재화등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을
                                            훼손한 경우
                                        </p>
                                        <p>
                                            5. 전자상거래 "사이트"에서 제공하는 세미나를 신청, 대금 지급 후 적절한
                                            철회의사를 세미나 시작후 2일이내까지 표시하지 않은 경우
                                        </p>
                                        <p>
                                            6. 전자상거래 "사이트"에서 제공하는 세미나를 신청, 대금 지급 후 해당
                                            세미나에 참석확인이 된 경우
                                        </p>
                                        <p className="mar_b5">
                                            ③ 제②항 제2호 내지 제4호의 경우에 전자상거래 "사이트"이 사전에 청약철회 등이
                                            제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나 시용상품을 제공하는
                                            등의 조치를 하지 않았다면 이용자의 청약철회등이 제한되지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 이용자는 제①항 및 제②항의 규정에 불구하고 재화등의 내용이 표시·광고 내용과
                                            다르거나 계약내용과 다르게 이행된 때에는 당해 재화등을 공급받은 날부터
                                            3월이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을
                                            할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 30 조 (전자상거래 사이트에서의 청약철회 등의 효과)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"는 이용자로부터 재화 등을 반환받은 경우 5영업일 이내에
                                            이미 지급받은 재화등의 대금을 환급한다. 이 경우 전자상거래 "사이트"가
                                            이용자에게 재화등의 환급을 지연한 때에는 그 지연기간에 대하여
                                            공정거래위원회가 정하여 고시하는 지연이자율을 곱하여 산정한 지연이자를
                                            지급합니다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 전자상거래 "사이트"는 위 대금을 환급함에 있어서 이용자가 신용카드 또는
                                            전자화폐 등의 결제수단으로 재화등의 대금을 지급한 때에는 지체없이 당해
                                            결제수단을 제공한 사업자로 하여금 재화등의 대금의 청구를 정지 또는
                                            취소하도록 요청한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 청약철회등의 경우 공급받은 재화등의 반환에 필요한 비용은 이용자가
                                            부담한다. 전자상거래 "사이트"은 이용자에게 청약철회등을 이유로 위약금 또는
                                            손해배상을 청구하지 않는다. 다만 재화등의 내용이 표시·광고 내용과 다르거나
                                            계약내용과 다르게 이행되어 청약철회등을 하는 경우 재화등의 반환에 필요한
                                            비용은 전자상거래 "사이트"가 부담한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 이용자가 재화등을 제공받을때 발송비를 부담한 경우에 전자상거래 "사이트"은
                                            청약철회시 그 비용을 누가 부담하는지를 이용자가 알기 쉽도록 명확하게
                                            표시한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 31 조 (전자상거래 사이트에서의 환급)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"는 이용자가 구매신청한 재화등이 품절 등의 사유로 인도
                                            또는 제공을 할 수 없을 때에는 지체없이 그 사유를 이용자에게 통지하고 사전에
                                            재화 등의 대금을 받은 경우에는 대금을 받은 날부터 5영업일 이내에, 그렇지
                                            않은 경우에는 그 사유 발생일로부터 5영업일 이내에 계약해제 및 환급절차를
                                            취한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 전자상거래 "사이트"에서 제공하는 세미나 서비스인 경우는 세미나
                                            시작전일까지 철회의사를 표시한 회원에게만 환급절차를 취한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 제②항의 규정에 따라 세미나 시작전일까지 철회의사를 표시한 경우는 환급에
                                            소요되는 필요한 경비는 전자상거래 "사이트"에서 부담하나, 세미나 시작후
                                            2일이내에 철회의사를 표시한 경우는 환급에 소요되는 필요한 경비는 이용자가
                                            부담합니다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 32 조 (서비스 환불)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 원칙적으로 "서비스" 이용료를 환불하지 않는다. 특히, 다음 각
                                            호의 경우는 이용료 환불 불가 외에 다른 제재 조치를 취할 수 있다.
                                        </p>
                                        <p>1. 회원이 서비스 이용규정 위반이 명백한 경우</p>
                                        <p>
                                            2. 치과회원 약관 제18조에 의거 회원이 불량 공고를 등록하고 유료 서비스를
                                            신청한 경우
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 다음 각 호에 경우에는 이용료를 환불할 수 있다.
                                        </p>
                                        <p>1. 유료 서비스 이용이 개시되지 않은 경우</p>
                                        <p>2. 네트워크 또는 시스템 장애로 서비스 이용이 불가능한 경우</p>
                                        <p className="mar_b5">
                                            ③ 이용료를 환불받고자 하는 "회원"은 "사이트"에 유선 상의 방법으로 환불을
                                            요청해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 "회원"으로부터 전항의 요청을 받는 즉시 사실 확인 후, 환불
                                            요건에 부합하는 경우 정당한 사유 없이 이용료 환불을 거부할 수 없다.
                                        </p>
                                        <p className="mar_b5">⑤ 전자상거래 "사이트"를 이용한 경우는 제 31조를 따른다</p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 32 조 (제휴를 통한 서비스)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 제휴 관계를 체결한 여타 인터넷 웹 사이트 및 신문, 잡지 등의
                                            오프라인 매체를 통해 사이트에 등록한 "회원"의 이력서 정보가 열람될 수 있도록
                                            서비스를 제공할 수 있다. 단, 제휴 서비스를 통해 노출되는 이력서의 연락처
                                            정보는 제10조의 각 항에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 제휴를 통해 타 사이트 및 매체에 등록될 수 있음을 고지해야 하며,
                                            제휴 사이트 목록을 사이트내에서 상시 열람할 수 있도록 해야 한다. 단, 등록의
                                            형태가 "사이트"가 직접 구축하지 않고, 제휴사가 xml 또는 api 형태로
                                            "사이트"로부터 제공 받아 구축한 매체 목록은 본 약관외 별도의 제휴리스트에서
                                            열람할 수 있도록 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 사이트와 제휴를 통해 "회원"이 공개를 요청한 이력서에 한해
                                            이력서 정보를 제공한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "③호" 제휴를 통한 사이트의 변동사항 발생 시 공지사항을 통해 고지 후 진행
                                            한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>부 칙</strong>
                                        </p>
                                        <p>- 본 이용약관은 공정거래위원회의 전자상거래 표준약관을 준수합니다.</p>
                                        <p>- 이 약관은 2026년 9월 1일부터 시행됩니다.</p>
                                        <br />
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="title-terms">
                                    <label className="reg__label">
                                        <input
                                            type="checkbox"
                                            name="accept-2"
                                            defaultValue="accept"
                                            className="reg__checkbox"
                                            checked={checkboxes['accept-2']}
                                            onChange={handleCheckboxChange}
                                        />
                                    </label>
                                    <p>
                                        <span className="flex">
                                            <span>이용약관동의 - 덴탈비타민, 덴탈세미나 </span>
                                        </span>
                                        <strong>(필수)</strong>
                                        <span className="view-more-btn" onClick={() => toggleTermsContent(1)}>
                                            <span className="star">※</span>
                                            <span>이용약관 전문보기</span>
                                        </span>
                                    </p>
                                </div>
                                <div className={`content-terms ${activeTerms[1] ? 'active' : ''}`}>
                                    <div className="contracts">
                                        <p className="mar_b10">
                                            <strong>제 1 조 (목적)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            본 약관은 주식회사 신흥(이하 "회사")이 제공하는 웹사이트(이하 "사이트")를
                                            통해 인터넷 관련 서비스(이하 "서비스")를 제공함에 있어, 사이트가 제공하는
                                            서비스와 관련하여, 이를 이용하는 이용자(이하 "회원")의 이용조건 및 제반
                                            절차, 기타 필요한 사항을 규정함을 목적으로 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 2 조 (용어의 정의)</strong>
                                        </p>
                                        <p className="mar_b5">이 약관에서 사용하는 용어의 정의는 아래와 같다.</p>
                                        <p className="mar_b5">
                                            ① "사이트"라 함은 서비스를 이용자에게 제공하기 위하여 컴퓨터 등
                                            정보통신설비를 이용하여 설정한 가상의 영업장 또는 웹사이트, 모바일웹, 앱
                                            등의 서비스를 제공하는 모든 매체를 말하며, 통합된 하나의 아이디 및
                                            비밀번호(이하 "통합계정")를 이용하여 "서비스" 를 제공받을 수 있는 아래의
                                            "사이트"로 정의한다.
                                        </p>
                                        <p>- 구인구직정보제공 : www.dentaljob.co.kr</p>
                                        <p>- 온라인정보제공 : www.dentalvitamin.com, www.dentalseminar.co.kr</p>
                                        <p>- 전자상거래(상품주문, 세미나신청) : www.dvmall.co.kr</p>
                                        <p className="mar_b5">
                                            ② "서비스"란 사이트를 통해 개인 또는 기업, 단체가 구직 또는 구인을 목적으로
                                            제공하는 자료를 DB화하여 각각의 목적에 맞게 자료를 가공, 집계하여 정보를
                                            제공하는 서비스와 취업 및 채용에 관련된 부가정보 서비스, 온라인 구매와
                                            세미나 및 이벤트, 프로모션 등의 정보제공을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "회원"이라 함은 서비스를 이용하기 위하여 동 약관에 동의하고 "사이트"와
                                            이용계약을 체결하여 이용자ID를 부여받은 개인을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "개인회원"이라 함은 구직을 목적으로 하는 개인이 본 서비스를 이용하기
                                            위하여 동 약관에 동의하고 "사이트"와 이용계약을 체결하여 이용자ID를 부여받은
                                            "회원"을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "치과회원"이라 함은 자사의 직접 고용의 목적으로 채용을 원하는 병의원
                                            단체(이하 "업체")나 구인을 목적으로 하는 개인이 본 서비스를 이용하기 위하여
                                            동 약관에 동의하고 "사이트"와 이용계약을 체결하여 이용자ID를 부여받은
                                            "회원"을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ "비회원"이라 함은 회원가입 절차를 거치지 않고 "사이트"가 제공하는 서비스를
                                            이용하거나 하려는 자를 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ "이용자"란 "사이트"가 제공하는 서비스를 받는 회원 및 비회원을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑧ "이용자ID" 또는 "회원ID"라 함은 "회원"의 식별과 "회원"의 "서비스" 이용을
                                            위하여 "회원"이 선정하고 "사이트"가 부여하는 문자와 숫자의 조합을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑨ "비밀번호"라 함은 "사이트"의 "서비스"를 이용하려는 사람이 "이용자ID"를
                                            부여받은 자와 동일인임을 확인하고 회원의 권익을 보호하기 위하여 회원이
                                            선정한 문자와 숫자의 조합을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑩ "세미나 참가비"라 함은 "사이트"에서 제공하는 세미나에 참석하는 대가로
                                            회사가 별도로 정한 요금체계에 의해 부과되는 비용을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑪ "주문"이라 함은 "사이트"에서 제공하는 서비스를 이용하기 위해 컨텐츠,
                                            재화등을 신청하는 것을 말한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 3 조 (약관의 명시와 개정)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 이 약관의 내용과 상호, 영업소 소재지, 대표자의 성명,
                                            사업자등록번호, 연락처 등을 이용자가 알 수 있도록 초기 화면에 게시하거나
                                            기타의 방법으로 이용자에게 공지해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 약관의 규제에 관한 법률, 전자거래기본법, 전자서명법,
                                            전기통신기본법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호,
                                            전자상거래등에서의 소비자보호에 관한법률 등에 관한 법률 등 관련법을 위배하지
                                            않는 범위에서 약관을 개정할 수 있으며, 변경된 약관은 "사이트" 화면에
                                            게시되거나 기타의 방법으로 "회원"에게 공지됨으로써 효력이 발생한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"가 약관을 개정할 경우 적용일자 및 개정사유를 명시하여 현행약관과
                                            함께 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지한다. 단
                                            "회원"의 권리, 의무에 중대한 영향을 주는 변경의 경우에는 적용일자 30일
                                            전부터 공지하도록 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "회원"는 변경된 약관에 대해 거부할 권리가 있다. "회원"는 변경된 약관이
                                            공지된 지 15일 이내에 거부 의사를 표명할 수 있다. "회원"가 거부하는 경우 본
                                            "서비스" 제공자인 "사이트"는 15일의 기간을 정하여 "회원"에게 사전 통지 후
                                            당해 "회원"와의 계약을 해지할 수 있다. 만약, "회원"가 거부 의사를 표시하지
                                            않고 "서비스"를 계속 이용하는 경우에는 동의하는 것으로 간주한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 4조 (약관의 해석)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 이 약관에서 규정하지 않은 사항에 관해서는 약관의 규제 등에 관한 법률,
                                            전기통신기본법, 전기통신사업법, 정보통신망이용촉진등에관한법률 등의
                                            관계법령에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 각 사이트 및 서비스 이용약관이 있는 경우에는 서비스 이용약관이 우선한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "회원"이 "사이트"와 개별 계약을 체결하여 서비스를 이용할 경우에는 개별
                                            계약이 우선한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 5 조 (이용계약의 성립)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"의 서비스 이용계약(이하 '이용계약'이라 한다)은 서비스를 이용하고자
                                            하는 자의 본 약관과 개인정보보호정책의 내용에 대한 동의 및
                                            이용신청(회원가입신청)에 대하여 "사이트"가 승낙함으로써 성립한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 서비스를 이용하고자 하는 자가 이용신청 당시 웹상의 "동의함" 버튼을 누르면
                                            본 약관 및 개인정보보호정책에 대하여 동의한 것으로 간주한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 특히 치과회원으로 가입하고자 하는 치과병의원, 기공소, 종합병원등은 국내외
                                            사업자등록증을 보유하고 있는 업체에 한해 회원 가입을 허락한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 제1항의 승낙은 이용신청자의 본 약관에 대한 동의를 확인하고 웹 상의 안내
                                            또는 전자메일로 통지함으로써 이루어지고 이러한 승낙의 통지가 이용신청자에게
                                            도달하면 이용계약이 성립한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 구인구직정보제공 사이트의 인재정보에 개인회원이 구직활동을 위해 공개한
                                            이력서정보는 열람권한을 가진 치과회원에게 제공된다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 6 조 (서비스 이용신청)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회원으로 가입하여 본 서비스를 이용하고자 하는 이용자는 "사이트"에서
                                            요청하는 제반정보(업체명, 사업자등록번호, 대표자 이름, 가입자 이름,
                                            생년월일, 전화번호, 휴대폰번호 등)를 제공하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 실명으로 등록하지 않은 사용자는 일체의 권리를 주장할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 모든 치과회원은 반드시 업체명과 사업자등록번호를 제공하여야만 서비스를
                                            이용할 수 있다. 업체명과 사업자등록번호를 허위로 등록한 경우, 휴·폐업
                                            사업자등록번호로 등록한 경우에 사용자는 일체의 권리를 주장할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 타인의 명의를 도용하여 이용신청을 한 회원의 모든 ID는 삭제되며, 관계법령에
                                            따라 처벌을 받을 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 사업자등록번호가 없는 업체, 기관이나 단체는 "사이트"가 정한 별도의 절차에
                                            따라 이용신청을 할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 회원으로 가입하더라도 로그인하지 않은 상태에서 주문하는 경우는 회원주문이
                                            아니라 비회원주문으로 인정한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 7 조 (이용신청의 승낙과 제한)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 전조의 규정에 의한 이용신청 고객에 대하여 업무수행상 또는
                                            기술상 지장이 없는 경우에는 원칙적으로 접수순서에 따라 서비스 이용을
                                            승낙한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 아래 사항에 해당하는 경우에 대해서는 이용신청을 승낙하지
                                            아니한다.
                                        </p>
                                        <p>
                                            1. 실제 업체명과 사업자등록번호가 아니거나 타사의 정보를 이용하여 신청한
                                            경우
                                        </p>
                                        <p>
                                            2. 이용계약 신청서의 내용을 허위로 기재하거나 "사이트"가 제시하는 내용을
                                            기재하지 않은 경우
                                        </p>
                                        <p>3. 본인의 생년월일이 아닌 경우</p>
                                        <p>4. 사회의 안녕 질서 또는 미풍양속을 저해할 목적으로 신청한 경우</p>
                                        <p>5. "사이트" 회원들의 보편적인 정서에 반하는 물의를 일으킨 경우</p>
                                        <p>6. "사이트"가 정한 기타 이용신청 요건에 맞지 않을 경우</p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 아래 사항에 해당하는 경우에는 그 신청에 대하여 승낙제한 사유가
                                            해소될 때까지 승낙을 유보할 수 있다.
                                        </p>
                                        <p>1. "사이트"가 설비의 여유가 없는 경우</p>
                                        <p>2. "사이트"의 기술상 지장이 있는 경우</p>
                                        <p>3. 기타 "사이트"의 귀책사유로 이용승낙이 곤란한 경우</p>
                                        <p className="mar_b5">
                                            ④ "회원"은 기재한 등록사항에 변경이 있는 경우, 즉시 전자우편 등 기타
                                            방법으로 그 변경 사항을 수정해야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 8 조 (서비스의 제공 및 변경)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 제2조 2항의 서비스를 제공할 수 있으며 그 내용은 다음 각 호와
                                            같습니다.
                                        </p>
                                        <p>1. 구인구직정보제공</p>
                                        <p>- 온라인 입사지원 서비스</p>
                                        <p>- 채용정보 등록서비스</p>
                                        <p>- 구인/구직과 관련된 제반 서비스</p>
                                        <p>- 이력서 열람 서비스</p>
                                        <p>2. 온라인정보제공</p>
                                        <p>- 뉴스레터 이메일 서비스</p>
                                        <p>- 상품 및 제품등의 프로모션 및 이벤트에 관련된 서비스</p>
                                        <p>3. 전자상거래</p>
                                        <p>- 재화등에 대한 정보 제공 및 구매계약의 체결</p>
                                        <p>- 구매계약이 체결된 재화등의 배송</p>
                                        <p>- 세미나등에 대한 정보 제공 및 신청계약의 체결</p>
                                        <p>- 신청계약이 체결된 세미나등의 제공</p>
                                        <p>4. 이용자간의 교류와 소통과 관련된 서비스</p>
                                        <p>5. 자료 거래에 관련된 서비스</p>
                                        <p>
                                            6. 기타 "사이트"가 추가 개발하거나 제휴계약 등을 통해 "회원"에게 제공하는
                                            일체의 서비스
                                        </p>
                                        <p>7. 기타 "사이트"에서 정하는 업무 및 일체의 서비스</p>
                                        <p className="mar_b5">
                                            ② "사이트"는 필요한 경우 서비스의 내용을 추가 또는 변경할 수 있다. 단, 이
                                            경우 "사이트"는 추가 또는 변경내용을 회원에게 공지해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 재화등의 품절 또는 기술적 사양의 변경 등의 경우에는 장차
                                            체결되는 계약에 의해 제공할 재화등의 내용을 변경할 수 있다. 이 경우에는
                                            변경된 재화등의 내용 및 제공일자를 명시하여 현재의 재화등의 내용을 게시한
                                            곳에 즉시 공지한다. 단, 사이트가 합리적으로 예측할 수 없는 불가피한 여건이나
                                            사정이 있는 경우, 위 공지를 하지 않을 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화등의 품절
                                            또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게
                                            통지 가능한 주소로 즉시 통지한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 9 조 (치과회원 정보, 채용공고 등록과 이력서 검색)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 치과회원은 구직을 원하는 개인회원이 채용공고를 열람한 후 해당 기업에 대한
                                            판단을 돕기 위해 기업정보를 정확히 기재하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 치과회원은 직업안정법 제34조 및 동법 시행령 제34조 거짓 구인공고의 범위에
                                            위배되지 않도록 채용공고를 작성하여 등록해야 하며 그 내용은 다음과 같다.
                                        </p>
                                        <p>
                                            1. 구인을 가장하여 물품판매, 수강생 모집, 직업소개, 부업알선, 자금모집 등을
                                            행하는 광고
                                        </p>
                                        <p>
                                            2. 허위 구인을 목적으로 구인자의 신원(업체명 또는 성명)을 표시하지 아니하는
                                            광고
                                        </p>
                                        <p>
                                            3. 구인자가 제시한 직종, 고용형태, 근로조건 등이 응모할 때의 그것과 현저히
                                            다른 광고
                                        </p>
                                        <p>4. 기타 광고의 중요내용이 사실과 다른 광고</p>
                                        <p>5. 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</p>
                                        <p>6. 공공질서 및 미풍양속에 위반되는 내용인 경우</p>
                                        <p>
                                            7. 현행법에 위배되는 내용이나 범죄적 행위에 결부된다고 인정되는 내용일 경우
                                        </p>
                                        <p>
                                            8. 사이트의 저작권 또는 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
                                        </p>
                                        <p>9. 게시판의 성격에 부합하지 않는 게시물의 경우</p>
                                        <p>
                                            10. 기타 관계 법규에 위배되는 내용이나, 사이트의 원활한 운영을 위하여
                                            운영자가 필요하다고 판단한 경우
                                        </p>
                                        <p className="mar_b5">
                                            ③ 치과회원은 남녀 고용 평등과 일, 가정 양립 지원에 관한 법률 제7조 및 관련
                                            법률에 의거하여 근로자의 모집 및 채용에 있어서 남녀, 연령을 차별하여서는
                                            아니되며 15세 미만 채용 모집을 할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 제2항, 제3항을 위반한 경우 이에 대한 책임은 전적으로 치과회원에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 치과회원이 등록한 정보 및 채용공고를 "사이트"가 정한 방법에
                                            의해 노출할 수 있으며, "사이트"가 지정한 기간이 지난 채용공고는 "사이트"가
                                            임의로 마감시킬 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 치과회원은 직원 채용의 목적으로 유·무료로 개인회원이 등록한 이력서를
                                            검색할 수 있으며 치과회원은 "사이트"가 제시하는 별도의 커뮤니케이션을 통하여
                                            개인회원에게 연락을 취할 수 있다. 단, 이력서 연락처의 열람 및 연락의 목적은
                                            직원 채용활동에 국한되어야 하며, 기업의 영업ㆍ마케팅ㆍ제3자 제공 시에는
                                            개인정보보호법, 직업안정법, 정보통신망 이용 촉진 및 정보 보호 등에 관한
                                            법률에 의거하여 법적 책임을 질 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ "사이트"는 "기업회원"이 이력서를 검색하고, "개인회원"에게 연락할 수 있는
                                            권한에 제한을 둘 수 있으며, "기업회원"이 적절하지 않은 방법으로
                                            "개인회원"에게 연락하거나, "개인회원"에게 불편을 끼친 경우, 채용공고 및
                                            회원정보를 임의로 수정/삭제할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑧ 치과회원이 자사의 직접 고용을 목적으로 하지 않는 공고를 등록할 경우
                                            "사이트"는 해당 공고를 삭제할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑨ 채용광고의 근무처 및 근무지역은 치과회원이 위치한 지역 및 근무처에 한해야
                                            한다. 본사에 지사, 지점, 영업소등을 포함하고 있는 경우는 개별 지사, 지점,
                                            영업소 단위로 채용광고를 해야 하며, 본사를 통한 일괄적인 채용광고는 할 수
                                            없다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 10 조 (개인회원 정보, 이력서 노출)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "개인회원"의 이력서는 개인이 회원가입 또는 이력서 작성 및 수정시 희망한
                                            형태로 이력서를 노출한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 개인회원이 회원정보, 이력서의 공개/비공개 지정, 이력서상의
                                            연락처 공개/비공개를 자유롭게 선택할 수 있도록 하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 개인회원이 이력서 공개를 희망했을 경우, 치과회원의 이력서
                                            열람에 동의한것으로 간주하며, "사이트"는 이들 회원에게 무료/유료로 이력서
                                            열람 서비스를 제공할 수 있다. 다만, 연락처 등 각 항목이 비공개로 지정된 경우
                                            해당 항목별 연락처를 노출할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 사이트는 개인회원이 등록한 이력서를 아이디 휴면상태 이전까지 노출할 수
                                            있으며, 사이트가 지정한 기간이 지난 이력서는 개인회원 탈퇴시 까지 관리할 수
                                            있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 안정적인 서비스를 제공하기 위해 테스트 및 모니터링 용도로
                                            "사이트" 운영자가 이력서 정보를 열람하도록 할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 11 조 (서비스의 요금)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회원 가입은 무료이며, 채용광고등록은 유료로 운영된다. 또한 개인회원 또는
                                            사이트에 방문한 회원에게 자신의 정보를 보다 효과적으로 노출시키기 위한
                                            추가적인 유료 서비스를 제공한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 유료서비스를 제공할 경우 사이트에 요금에 대해서 공지를 하여야
                                            한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 유료서비스 이용금액을 서비스의 종류 및 기간에 따라 "사이트"가
                                            예고 없이 변경할 수 있다. 다만, 변경 이전에 적용 또는 계약한 금액은 소급하여
                                            적용하지 아니한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 유료 서비스 신청 후 "회원" 사정에 의해 서비스가 취소될 경우, 정부가
                                            고시하는 '디지털콘텐츠 이용자보호지침'에 따라 "사이트"는 본 지침이 제시하는
                                            범위 내에서 환불 수수료를 부과할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 12 조 (서비스 이용시간)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 특별한 사유가 없는 한 연중무휴, 1일 24시간 서비스를 제공한다.
                                            다만, "사이트"는 서비스의 종류나 성질에 따라 제공하는 서비스 중 일부에
                                            대해서는 별도로 이용시간을 정할 수 있으며, 이 경우 "사이트"는 그 이용시간을
                                            사전에 회원에게 공지 또는 통지하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 자료의 가공과 갱신을 위한 시스템 작업시간, 장애해결을 위한
                                            보수작업 시간, 정기 PM작업, 시스템 교체작업, 회선 장애 등이 발생한 경우
                                            일시적으로 서비스를 중단할 수 있으며 계획된 작업의 경우 공지란에 서비스 중단
                                            시간과 작업 내용을 알려야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 13 조 (서비스 제공의 중지)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 다음 각 호에 해당하는 경우 서비스의 제공을 중지할 수 있다.
                                        </p>
                                        <p>1. 설비의 보수 등 "사이트"의 필요에 의해 사전에 회원들에게 통지한 경우</p>
                                        <p>2. 기간통신사업자가 전기통신서비스 제공을 중지하는 경우</p>
                                        <p>3. 기타 불가항력적인 사유에 의해 서비스 제공이 객관적으로 불가능한 경우</p>
                                        <p className="mar_b5">
                                            ② 전항의 경우, "사이트"는 기간의 정함이 있는 유료서비스 이용자들에게는 그
                                            이용기간을 연장하는 등의 방법으로 손실을 보상하여야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 14 조 (정보의 제공 및 광고의 게재)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 회원에게 서비스 이용에 필요가 있다고 인정되거나 서비스 개선 및
                                            회원대상의 서비스 소개 등의 목적으로 하는 각종 정보에 대해서 전자우편이나
                                            서신우편을 이용한 방법으로 제공할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 제공하는 서비스와 관련되는 정보 또는 광고를 서비스 화면,
                                            홈페이지 등에 게재할 수 있으며, 회원들에게 메일을 통해 알릴 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 서비스상에 게재되어 있거나 본 서비스를 통한 광고주의 판촉활동에
                                            회원이 참여하거나 교신 또는 거래를 함으로써 발생하는 모든 손실과 손해에 대해
                                            책임을 지지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 본 서비스의 회원은 서비스 이용 시 노출되는 광고게재에 대해 동의 하는
                                            것으로 간주한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 15 조 (자료내용의 책임과 "사이트"의 정보 수정 권한)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 자료내용은 회원이 등록한 업체정보, 채용공고, 이력서정보 및 사이트에 게시한
                                            게시물을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회원은 자료 내용 및 게시물을 사실에 근거하여 성실하게 작성해야 하며, 만일
                                            자료의 내용이 사실이 아니거나 부정확하게 작성되어 발생하는 모든 책임은
                                            회원에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 모든 자료내용의 관리와 작성은 회원 본인이 하는 것이 원칙이나 사정상 위탁
                                            또는 대행관리를 하더라도 자료내용의 책임은 회원에게 있으며 회원은 주기적으로
                                            자신의 자료를 확인하여 항상 정확하게 관리가 되도록 노력해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 회원이 등록한 자료 내용에 오자, 탈자 또는 사회적 통념에
                                            어긋나는 문구와 내용이 있을 경우 이를 언제든지 수정할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 "회원"이 등록한 자료를 "사이트"가 운영하는 같은 목적의 타
                                            "사이트"에도 게재할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ "회원"이 등록한 자료로 인하여 타인(또는 타법인)으로부터 허위사실 및
                                            명예훼손 등으로 삭제요청이 접수된 경우 "사이트"는 "회원"에게 사전 통지 없이
                                            본 자료를 삭제할 수 있으며, 자료 삭제후 메일 등의 방법으로 "회원"에게 통지할
                                            수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ "사이트"는 다음 각 호에 해당하는 경우 회원의 동의를 받아 회원이 신청한
                                            정보를 변경할 수 있다.
                                        </p>
                                        <p>
                                            - 아이디가 회원의 전화번호, 생년월일 등으로 등록되어 있어서 회원의 사생활을
                                            침해할 우려가 있는 경우
                                        </p>
                                        <p>- 고객센터문의, 이메일 등의 방법을 통해 변경요청하는 경우</p>
                                        <p>- 기타 "사이트"의 기술상 현저히 지장이 있다고 판단되는 경우</p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 16 조 (회사의 의무)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회사는 본 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 수
                                            있도록 최선의 노력을 다해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회사는 서비스와 관련한 회원의 불만사항이 접수되는 경우 이를 즉시
                                            처리하여야 하며, 즉시 처리가 곤란한 경우에는 그 사유와 처리일정을 서비스
                                            화면 또는 기타 방법을 통해 동 회원에게 통지하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 회사는 유료 결제와 관련한 결제 사항 정보를 1년 이상 보존한다. 다만 회원
                                            자격이 없는 회원은 예외로 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 천재지변 등 예측하지 못한 일이 발생하거나 시스템의 장애가 발생하여
                                            서비스가 중단될 경우 이에 대한 손해에 대해서는 회사가 책임을 지지 않는다.
                                            다만 자료의 복구나 정상적인 서비스 지원이 되도록 최선을 다할 의무를 진다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 회원의 자료를 본 서비스 이외의 목적으로 제3자에게 제공하거나 열람시킬 경우
                                            반드시 회원의 동의를 얻어야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 치과회원이 사이트에 등록한 치과정보, 채용공고 내용은 사이트를 방문하는
                                            일반 대중에게 공개함을 원칙으로 하며 회사는 공개 기간을 지정할 수 있다. 단,
                                            일부 비공개 항목은 회사에서 제시하는 별도의 옵션을 통해 지정할 수 있으며,
                                            회사는 이 항목에 대한 비공개 의무를 진다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ 구직자의 정보의 정확성은 구인자가 직접 확인하여야 하며 회사는 이와
                                            관련하여 어떠한 책임도 지지 아니한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 17 조 (회원의 의무)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회원은 관계법령과 본 약관의 규정 및 기타 "사이트"가 통지하는 사항을
                                            준수하여야 하며, 기타 "사이트"의 업무에 방해되는 행위를 해서는 안된다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회원이 신청한 유료서비스는 등록 또는 신청과 동시에 "사이트"와 채권, 채무
                                            관계가 발생하며, 회원은 이에 대한 요금을 지정한 기일 내에 납부하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 회원이 결제 수단으로 신용카드를 사용할 경우 비밀번호 등 정보 유실 방지는
                                            회원 스스로 관리해야 한다. 단, 사이트의 결함에 따른 정보유실의 발생에 대한
                                            책임은 회원의 의무에 해당하지 아니한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 회원은 서비스를 이용하여 얻은 정보를 "사이트"의 사전동의 없이 복사, 복제,
                                            번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 회원은 본 서비스를 건전한 직원채용 이외의 목적으로 목적으로 사용해서는
                                            안되며 이용 중 다음 각 호의행위를 해서는 안된다.
                                        </p>
                                        <p>1. 다른 회원의 아이디를 부정 사용하는 행위</p>
                                        <p>2. 범죄행위을 목적으로 하거나 기타 범죄행위와 관련된 행위</p>
                                        <p>3. 타인의 명예를 훼손하거나 모욕하는 행위</p>
                                        <p>4. 타인의 지적재산권 등의 권리를 침해하는 행위</p>
                                        <p>5. 해킹행위 또는 바이러스의 유포 행위</p>
                                        <p>
                                            6. 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 계속적으로 전송하는
                                            행위
                                        </p>
                                        <p>7. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있다고 판단되는 행위</p>
                                        <p>8. 사이트의 정보 및 서비스를 이용한 영리 행위</p>
                                        <p>9. 그밖에 선량한 풍속, 기타 사회질서를 해하거나 관계법령에 위반하는 행위</p>
                                        <p className="mar_b5">
                                            ⑥ 치과회원은 "사이트"를 통해 열람한 이력서 정보를 "사이트" 및 당사자의
                                            허락없이 재배포할 수 없으며 본 정보에 대한 출력 및 복사 등의 관리 책임은
                                            전적으로 치과회원에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ 아이디(ID)와 비밀번호의 관리에 대한 책임은 "회원"에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑧ "회원"은 자신의 아이디(ID)를 타인에게 양도, 증여할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑨ 자신의 아이디(ID)가 부정하게 사용된 경우, "회원"은 반드시 "사이트"에 그
                                            사실을 통보해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑩ "회원"은 본 "사이트"에 규정한 제반 준수 사항을 바탕으로 회원의 신용을
                                            평가받게 된다.
                                        </p>
                                        <p className="mar_b5">⑪ 자료 공개 방식은 스스로 결정해서 관리한다.</p>
                                        <p className="mar_b5">
                                            ⑫ "회원"은 자신의 비밀번호를 분실한 경우 임시비밀번호를 발급받아 새로운
                                            비밀번호로 변경해야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 18 조 (회원의 가입해지/서비스중지/자료삭제)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "회원"은 언제든지 회원탈퇴 또는 채용공고 등록을 해지하기 위해 고객센터
                                            또는 회원탈퇴 메뉴 등을 통하여 이용계약 해지 신청을 할 수 있으며,
                                            가입해지시는 해지사유를 밝혀야 한다. 또한 "사이트"는 관련법 등이 정하는 바에
                                            따라 이를 처리해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 다음의 사항에 해당하는 경우 "사이트"는 사전 동의없이 가입해지나 서비스
                                            중지, 채용공고 삭제 조치를 취할 수 있다.
                                        </p>
                                        <p>1. 회원의 의무를 성실하게 이행하지 않았을 때</p>
                                        <p>2. 규정한 유료서비스 이용 요금을 납부하지 않았을 때</p>
                                        <p>3. 불순한 의도로 유료서비스를 반복적으로 결제/취소할 때</p>
                                        <p>
                                            4. 본 서비스 목적에 맞지 않는 분야에 정보를 활용하여 사회적 물의가 발생한 때
                                        </p>
                                        <p>5. 회원이 등록한 정보의 내용이 사실과 다르거나 조작되었을 때</p>
                                        <p>6. 사업자등록증에 나타난 정보와 기업회원 가입시의 정보가 일치하지 않을 때</p>
                                        <p>
                                            7. 타 기업의 사업자등록번호나 상호를 도용하여 허위로 기업정보를 등록하거나
                                            휴·폐업 사업자등록번호로 기업정보를 등록했을 때
                                        </p>
                                        <p>
                                            8. 지사, 지점, 영업소 등의 경우 구체적인 지사, 지점, 영업소 명칭을 사용하지
                                            않고 기업명을 등록했거나 지사, 지점, 영업소의 사업자등록번호가 별도 있음에도
                                            불구하고 본사의 사업자등록번호로 기업회원 가입을 했을 때
                                        </p>
                                        <p>
                                            9. 사이트명, 담당자 성명, 사무실 연락처 등 구인업체의 중요 정보를 정확하게
                                            기입하지 않았을 때
                                        </p>
                                        <p>
                                            10. 치과회원 가입 또는 채용공고 등록시 본 서비스에서 안내하는 방법으로
                                            가입하지 않았거나 등록하지 않았을 때
                                        </p>
                                        <p>11. 동일 회원 ID로 게재 중인 동일 내용 채용공고를 중복 등록했을 때</p>
                                        <p>12. 동일 사업자가 특별한 이유 없이 중복 가입했을 때</p>
                                        <p>
                                            13. 동일 사업자가 마감일이 지나지 않은 사실상의 동일내용의 채용공고를 다수
                                            ID를 사용하여 중복등록 했을 때
                                        </p>
                                        <p>14. 허위 구인공고를 등록했을 때</p>
                                        <p>15. 작성자가 제시한 직종, 업무내용, 근로조건 등이 실제와 현저히 다를 때</p>
                                        <p>16. 채용공고의 모집요강만으로 업무에 대한 내용이 명확하지 않을 때</p>
                                        <p>17. 모집요강에 적합한 업직종 분류를 지정하지 않았을 때</p>
                                        <p>
                                            (특히, 교육기관이나 이벤트업체 또는 영업대행기관의 경우 영업, 마케팅,
                                            텔레마케팅, 상담인력을 모집하고자 할 경우 반드시 텔레마케팅 또는 고객상담,
                                            교육/강사/학원등 반드시 직접 관련되는 해당 업종, 직종분류만 지정해야 한다.)
                                        </p>
                                        <p>18. 다단계, 피라미드 식의 모집 내용을 등록했을 때</p>
                                        <p>
                                            19. 구인을 가장하여 유학알선, 물품판매, 자금 모금 등을 행하는 내용을
                                            등록했을 때
                                        </p>
                                        <p>20. 교육비, 수강료를 요구하는 수강생 모집광고, 학원 광고를 등록했을 때</p>
                                        <p>
                                            21. 회원모집 형태의 광고 또는 카드회원 모집(수당제 광고) 내용을 등록했을 때
                                        </p>
                                        <p>
                                            22. 추천인 모집 광고, 재택 쇼핑몰 분양 광고, 직업소개, 부업알선 광고를
                                            등록했을 때
                                        </p>
                                        <p>
                                            23. 취업수수료 등 취업 관련 비용을 필요로 하는 채용공고를 등록했을 때 (운송,
                                            물류, 지입, 인력용역 등)
                                        </p>
                                        <p>24. 불건전한 내용의 유흥업소 채용공고를 등록했을 때</p>
                                        <p>
                                            25. 구직자의 피해사례가 (채용공고를 통해 구직자가 입사 과정에서 피해가
                                            발생한 경우 또는 재직중 "치과회원"이 관계법령을 위반하여 피해가 발생한 경우
                                            등)가 접수된 채용공고
                                        </p>
                                        <p>26. 임금체불 사실이 접수되었거나 근로감독원에 진정서가 접수되어 있는 기업</p>
                                        <p>
                                            27. 사업자 모집, 프랜차이즈 모집, 점포개설, 창업 등 직원 채용이 아닌 공고를
                                            등록했을때
                                        </p>
                                        <p>
                                            28. 메일이나 문자메시지 수신자가 스팸으로 신고하거나 회원이 발송하는
                                            메시지가 불법 스팸임이 판명될 경우
                                        </p>
                                        <p>
                                            29. 방송통신위원회 또는 한국정보보호진흥원이 불법 스팸 전송 사실을 확인하여
                                            이용 정지를 요청하는 경우
                                        </p>
                                        <p>
                                            30. 미래창조과학부(거짓으로 표시된 전화번호로 인한 이용자 피해 예방에 관한)
                                            고시 제2015-32호 제10조 제1항에 따라 미래창조과학부 또는 중앙전파관리소,
                                            한국 인터넷진흥원(KISA)에서 번호 변작 등으로 판명되어 이용 정지를 요청한
                                            경우
                                        </p>
                                        <p>31. 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</p>
                                        <p>
                                            32. 사이트의 저작권 또는 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
                                        </p>
                                        <p>33. 게시판의 성격에 부합하지 않는 게시물의 경우</p>
                                        <p>34. 공공질서 및 미풍양속에 위반되는 내용인 경우</p>
                                        <p>35. 회원들의 보편적인 정서에 반하는 물의를 일으킨 경우</p>
                                        <p>
                                            36. 기타 관계법규에 위배되는 내용이거나 사이트의 원활한 운영을 위하여
                                            운영자가 필요하다고 판단한 경우
                                        </p>
                                        <p>
                                            37. 기타 본 서비스 명예를 훼손하였거나 사이트가 판단하기에 적합하지 않은
                                            목적으로 회원가입을 하였을 때
                                        </p>
                                        <p>
                                            38. "회원"으로 등록하는 것이 "사이트"의 기술상 현저히 지장이 있다고 판단되는
                                            경우
                                        </p>
                                        <p className="mar_b5">
                                            ③ 회원이 유료서비스를 이용하는 중 "사이트"의 책임에 의해 정상적인 서비스가
                                            제공되지 않을 경우 회원은 본 서비스의 해지를 요청할 수 있으며 "사이트"는
                                            기간의 정함이 있는 유료서비스의 경우에는 해지일까지 이용일수를 1일
                                            기준금액으로 계산하여 이용금액을 공제후 환급하고, 이용건수의 정함이 있는
                                            유료서비스의 경우에는 기 사용분을 1건 기준금액으로 계산하여 이용금액을
                                            공제후 환급하거나 기간연장등의 방법으로 보상합니다. 단, 허위·불량공고의 경우
                                            게재시 지불된 광고료는 일체 반환되지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 회원 가입이 해지된 경우 해당 회원 정보를 모두 삭제하여야 하며,
                                            상법, 전자상거래등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여
                                            보존할 필요가 있는 경우 관계법령에서 정한 일정한 기간 동안 회원정보를
                                            보관한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 1년이상 "회원"의 관리 없이 방치되고 있다고 판단되는 "회원"의
                                            자료는 임의로 삭제할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 개인정보보호를 위하여 "회원"이 선택한 개인정보 보유기간(1년) 동안
                                            "사이트"를 이용하지 않은 경우, "아이디"를 "휴면계정"으로 분리하여 해당
                                            계정의 이용을 중지할 수 있다. 이 경우 "사이트"는 "휴면계정 처리
                                            예정일"로부터 30일 이전에 해당사실을 전자메일, 서면, SMS 중 하나의 방법으로
                                            사전통지하며 "회원"이 직접 본인확인을 거쳐, 다시 "사이트" 이용 의사표시를 한
                                            경우에는 "사이트" 이용이 가능하다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 19 조 (허위 구인광고 경고)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            허위 구인광고로 인해 발생된 문제에 따른 법적인 책임은 모두 작성자에게
                                            있으며, 구인광고 게재시에 지불된 광고료는 일체 반환되지 않습니다. 허위
                                            구인광고 또는 허위 구인 조건을 제시한 자는 직업 안정법 제 47조에 의해 5년
                                            이하의 징역 또는 2천만원 이하의 벌금형을 받게 된다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 20 조 (손해배상)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"가 이 약관의 제8조, 제16조, 제18조 등의 규정에 위반한 행위로
                                            이용자에게 손해를 입히거나 기타 "사이트"가 제공하는 모든 서비스와 관련하여
                                            "사이트"의 책임 있는 사유로 인해 이용자에게 손해가 발생한 경우 "사이트"는 그
                                            손해를 배상하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회원이 이 약관의 제6조, 제17조, 제18조 등의 규정에 위반한 행위로 "사이트"
                                            및 제3자에게 손해를 입히거나 회원의 책임 있는 사유에 의해 "사이트" 및
                                            제3자에게 손해를 입힌 경우에는 회원은 그 손해를 배상하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 "서비스" 이용과 관련하여 "회원"에게 발생한 손해 가운데 "회원"의
                                            고의, 과실 및 "회원"의 귀책사유로 인한 "서비스" 이용의 장애 및 손해에
                                            대하여는 책임을 지지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 "회원"이 "서비스"를 이용하여 기대하는 수익을 얻지 못하거나
                                            상실한 것에 대하여 책임을 지지 않으며, "사이트"가 무료로 제공하는 "서비스"의
                                            이용과 관련하여 개인정보 처리방침에서 정하는 내용에 위반하지 않은 한 어떠한
                                            손해도 책임지지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할
                                            수 없는 경우 "서비스" 제공에 관한 책임이 면제된다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 21 조 (이용요금 오류의 조정)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            "사이트"는 이용요금과 관련하여 오류가 있는 경우에 이용자의 요청, 또는
                                            "사이트"의 사전 통지에 의하여 다음에 해당하는 조치를 취한다.
                                        </p>
                                        <p className="mar_b5">
                                            ① 과다납입한 요금에 대하여는 그 금액을 반환하거나 이용기간을 조정한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 요금을 반환받아야 할 이용자가 요금체납이 있는 경우에는 반환해야 할
                                            요금에서 이를 우선 공제하고 반환한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 과소청구액에 대해서는 익월에 합산청구한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 22 조 (회원의 개인정보보호)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            "사이트"는 이용자의 개인정보보호를 위하여 노력해야 한다. 이용자의
                                            개인정보보호에 관해서는 정보통신망이용촉진 및 정보보호 등에 관한 법률에
                                            따르고, 사이트에 "개인정보취급방침"을 고지한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 23조 (신용정보의 제공 활용 동의)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"가 회원가입과 관련하여 취득한 "회원"의 신용 정보를 타인에게
                                            제공하거나 활용하고자 할 때에는 신용 정보의 이용 및 보호에 관한 법률
                                            제32조의 규정에 따라 사전에 그 사유 및 해당기관 또는 업체명 등을 밝히고 해당
                                            "회원"의 동의를 얻어야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 본 "서비스"와 관련하여 "사이트"가 "회원"으로부터 신용 정보 이용 및 보호에
                                            관한 법률에 따라 타인에게 정보제공 활용에 동의를 얻은 경우 "회원"은
                                            "사이트"가 신용 정보 사업자 또는 신용 정보 집중기관에 정보를 제공하여
                                            "회원"의 신용을 판단하기 위한 자료로 활용하거나, 공공기관에서 정책자료로
                                            활용되도록 정보를 제공하는 데 동의한 것으로 간주한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 24 조 (분쟁의 해결)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"와 회원은 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여
                                            필요한 모든 노력을 하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 전항의 노력에도 불구하고, 동 분쟁에 관한 소송은 "사이트"의 주소지
                                            관할법원으로 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 25 조 (자료 내용의 활용 및 온라인 입사 지원 정보)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "치과회원"이 입력한 정보는 채용 및 고용동향 통계 자료로 활용될 수 있으며
                                            채용공고는 매체를 통해 언론에 배포될 수 있다. 단, 활용되는 정보 중 개인을
                                            식별할 수 있는 정보는 제외된다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 "사이트"의 온라인 입사 지원 시스템을 통해 지원한 "개인회원"이
                                            자신의 이력서 열람 여부 및 지원자 통계 자료를 "개인회원"에게 제공할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"가 작성한 게시물 또는 저작물에 대한 저작권 및 기타 지적 재산권은
                                            "사이트"에 귀속한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "회원"이 "사이트" 내에 게시한 게시물의 저작권은 "회원"에게 귀속된다. 단,
                                            "회원"은 자신이 창작, 등록한 게시물에 대해 무상의 비독점적 사용권을
                                            "사이트"에 부여하고, 이 사용권은 "사이트"가 "사이트"를 운영하는 동안 계속
                                            유효하며, "회원" 탈퇴한 후에도 이와 같다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 게시물에 대한 권리와 책임은 게시물을 게시한 "회원"에게 있으며, "사이트"는
                                            "회원"의 동의 없이 이를 "사이트"가 운영하는 "사이트" 이외에 영리적 목적으로
                                            사용할 수 없다. 단, 비영리적인 경우에는 해당되지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ "사이트"에서 정당한 절차를 거쳐 "치과회원"이 열람한 개인 "회원"의 이력서
                                            정보는 해당 업체의 인사 자료이며, 이에 대한 관리 권한은 해당 업체의 정책에
                                            따른다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 26 조 (전자상거래 사이트에서의 구매 및 이용신청)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "이용자"는 전자상거래 "사이트"상에서 다음 또는 이와 유사한 방법에 의하여
                                            구매를 신청하며, 전자상거래 "사이트"는 이용자가 구매신청을 함에 있어서
                                            다음의 각 내용을 알기 쉽게 제공하여야 한다. 단, 회원인 경우 제2호 내지
                                            제4호의 적용을 제외할 수 있다.
                                        </p>
                                        <p>1. 재화등의 검색 및 선택</p>
                                        <p>
                                            2. 성명, 주소, 연락처(전화번호/핸드폰/이메일), 배송정보(수취인, 주소,
                                            연락처) 등의 입력
                                        </p>
                                        <p>
                                            3. 약관내용, 청약철회권이 제한되는 서비스, 배송료,설치비 등의 비용부담과
                                            관련한 내용에 대한 확인
                                        </p>
                                        <p>
                                            4. 약관에 동의하고 위 3호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)
                                        </p>
                                        <p>
                                            5. 재화등의 구매신청 및 이에 관한 확인 또는 전자상거래 "사이트"의 확인에
                                            대한 동의
                                        </p>
                                        <p>6. 결제방법의 선택</p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 27 조 (전자상거래 사이트에서의 지급방법과 시기)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"에서 구매한 재화등에 대한 대금지급방법은 다음 각 호의
                                            방법중 가용한 방법으로 할 수 있다. 단, 전자상거래 "사이트"은 이용자의
                                            지급방법에 대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수
                                            없으며, 현재 서비스 중인 것으로만 한다.
                                        </p>
                                        <p>1. 폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체</p>
                                        <p>2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제</p>
                                        <p>3. 온라인무통장입금</p>
                                        <p>4. 전자화폐에 의한 결제</p>
                                        <p>
                                            5. 마일리지, 포인트 등 "사이트" 또는 전자상거래 "사이트"가 지급한 수단에
                                            의한 결제
                                        </p>
                                        <p>
                                            6. 전자상거래 "사이트"와 계약을 맺었거나 전자상거래 "사이트"가 인정한
                                            상품권에 의한 결제
                                        </p>
                                        <p>7. 기타 전자상거래 "사이트"에서 정하는 통상적인 방법의 대금결제 등</p>
                                        <p className="mar_b5">
                                            ② 전자상거래 "사이트"에서 구매한 재화등 온라인 구매에 대한 대금지급시기는 그
                                            신청일로부터 7일이내로 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 전자상거래 "사이트"에서 서비스하는 세미나 신청의 대금지급시기는 전자상거래
                                            "사이트"에서 정한 마감일까지로 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>
                                                제 28 조 (전자상거래 사이트에서의 수신확인통지,구매신청 변경 및 취소)
                                            </strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"는 이용자의 구매신청이 있는 경우 이용자에게
                                            수신확인통지를 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 수신확인통지를 받은 이용자는 의사표시의 불일치등이 있는 경우에는 수신확인
                                            통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 전자상거래
                                            "사이트"는 배송전에 이용자의 요청이 있는 경우에는 지체없이 그 요청에 따라
                                            처리하여야 한다. 다만 이미 대금을 지불한 경우에는 제29조의 청약철회 등에
                                            관한 규정에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 전자상거래 "사이트"에서 제공하는 세미나 서비스를 신청한 이용자 중 이미
                                            대금을 지불한 경우 제 15 조의 청약철회 등에 관한 규정에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 전자상거래 "사이트"은 이용자가 구매(주문)신청 후 제27조에 의한
                                            지급방법으로 그 신청일로부터 7일 이내 또는 전자상거래 "사이트"에서 정한
                                            마감일까지 상품(이용)대금에 대해 입금이 확인되지 않을 경우 전자상거래
                                            "사이트"는 별도 의사 표시 없이 구매계약을 해제하는 것으로 처리할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 29 조 (전자상거래 사이트에서의 청약철회 등)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"와 재화등의 구매에 관한 계약을 체결한 이용자는
                                            수신확인의 통지를 받은 날부터 7일 이내에는 청약의 철회를 할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 이용자는 재화등을 배송받은 경우 다음 각 호의 1에 해당하는 경우에는 반품 및
                                            교환등 청약철회를 할 수 없다.
                                        </p>
                                        <p>
                                            1. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우 (다만, 재화
                                            등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수
                                            있다.)
                                        </p>
                                        <p>
                                            2. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우
                                        </p>
                                        <p>
                                            3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화등의 가치가 현저히 감소한
                                            경우
                                        </p>
                                        <p>
                                            4. 같은 성능을 지닌 재화등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을
                                            훼손한 경우
                                        </p>
                                        <p>
                                            5. 전자상거래 "사이트"에서 제공하는 세미나를 신청, 대금 지급 후 적절한
                                            철회의사를 세미나 시작후 2일이내까지 표시하지 않은 경우
                                        </p>
                                        <p>
                                            6. 전자상거래 "사이트"에서 제공하는 세미나를 신청, 대금 지급 후 해당
                                            세미나에 참석확인이 된 경우
                                        </p>
                                        <p className="mar_b5">
                                            ③ 제②항 제2호 내지 제4호의 경우에 전자상거래 "사이트"이 사전에 청약철회 등이
                                            제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나 시용상품을 제공하는
                                            등의 조치를 하지 않았다면 이용자의 청약철회등이 제한되지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 이용자는 제①항 및 제②항의 규정에 불구하고 재화등의 내용이 표시·광고 내용과
                                            다르거나 계약내용과 다르게 이행된 때에는 당해 재화등을 공급받은 날부터
                                            3월이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을
                                            할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 30 조 (전자상거래 사이트에서의 청약철회 등의 효과)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"는 이용자로부터 재화 등을 반환받은 경우 5영업일 이내에
                                            이미 지급받은 재화등의 대금을 환급한다. 이 경우 전자상거래 "사이트"가
                                            이용자에게 재화등의 환급을 지연한 때에는 그 지연기간에 대하여
                                            공정거래위원회가 정하여 고시하는 지연이자율을 곱하여 산정한 지연이자를
                                            지급합니다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 전자상거래 "사이트"는 위 대금을 환급함에 있어서 이용자가 신용카드 또는
                                            전자화폐 등의 결제수단으로 재화등의 대금을 지급한 때에는 지체없이 당해
                                            결제수단을 제공한 사업자로 하여금 재화등의 대금의 청구를 정지 또는
                                            취소하도록 요청한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 청약철회등의 경우 공급받은 재화등의 반환에 필요한 비용은 이용자가
                                            부담한다. 전자상거래 "사이트"은 이용자에게 청약철회등을 이유로 위약금 또는
                                            손해배상을 청구하지 않는다. 다만 재화등의 내용이 표시·광고 내용과 다르거나
                                            계약내용과 다르게 이행되어 청약철회등을 하는 경우 재화등의 반환에 필요한
                                            비용은 전자상거래 "사이트"가 부담한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 이용자가 재화등을 제공받을때 발송비를 부담한 경우에 전자상거래 "사이트"은
                                            청약철회시 그 비용을 누가 부담하는지를 이용자가 알기 쉽도록 명확하게
                                            표시한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 31 조 (전자상거래 사이트에서의 환급)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"는 이용자가 구매신청한 재화등이 품절 등의 사유로 인도
                                            또는 제공을 할 수 없을 때에는 지체없이 그 사유를 이용자에게 통지하고 사전에
                                            재화 등의 대금을 받은 경우에는 대금을 받은 날부터 5영업일 이내에, 그렇지
                                            않은 경우에는 그 사유 발생일로부터 5영업일 이내에 계약해제 및 환급절차를
                                            취한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 전자상거래 "사이트"에서 제공하는 세미나 서비스인 경우는 세미나
                                            시작전일까지 철회의사를 표시한 회원에게만 환급절차를 취한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 제②항의 규정에 따라 세미나 시작전일까지 철회의사를 표시한 경우는 환급에
                                            소요되는 필요한 경비는 전자상거래 "사이트"에서 부담하나, 세미나 시작후
                                            2일이내에 철회의사를 표시한 경우는 환급에 소요되는 필요한 경비는 이용자가
                                            부담합니다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 32 조 (서비스 환불)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 원칙적으로 "서비스" 이용료를 환불하지 않는다. 특히, 다음 각
                                            호의 경우는 이용료 환불 불가 외에 다른 제재 조치를 취할 수 있다.
                                        </p>
                                        <p>1. 회원이 서비스 이용규정 위반이 명백한 경우</p>
                                        <p>
                                            2. 치과회원 약관 제18조에 의거 회원이 불량 공고를 등록하고 유료 서비스를
                                            신청한 경우
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 다음 각 호에 경우에는 이용료를 환불할 수 있다.
                                        </p>
                                        <p>1. 유료 서비스 이용이 개시되지 않은 경우</p>
                                        <p>2. 네트워크 또는 시스템 장애로 서비스 이용이 불가능한 경우</p>
                                        <p className="mar_b5">
                                            ③ 이용료를 환불받고자 하는 "회원"은 "사이트"에 유선 상의 방법으로 환불을
                                            요청해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 "회원"으로부터 전항의 요청을 받는 즉시 사실 확인 후, 환불
                                            요건에 부합하는 경우 정당한 사유 없이 이용료 환불을 거부할 수 없다.
                                        </p>
                                        <p className="mar_b5">⑤ 전자상거래 "사이트"를 이용한 경우는 제 31조를 따른다</p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 32 조 (제휴를 통한 서비스)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 제휴 관계를 체결한 여타 인터넷 웹 사이트 및 신문, 잡지 등의
                                            오프라인 매체를 통해 사이트에 등록한 "회원"의 이력서 정보가 열람될 수 있도록
                                            서비스를 제공할 수 있다. 단, 제휴 서비스를 통해 노출되는 이력서의 연락처
                                            정보는 제10조의 각 항에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 제휴를 통해 타 사이트 및 매체에 등록될 수 있음을 고지해야 하며,
                                            제휴 사이트 목록을 사이트내에서 상시 열람할 수 있도록 해야 한다. 단, 등록의
                                            형태가 "사이트"가 직접 구축하지 않고, 제휴사가 xml 또는 api 형태로
                                            "사이트"로부터 제공 받아 구축한 매체 목록은 본 약관외 별도의 제휴리스트에서
                                            열람할 수 있도록 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 사이트와 제휴를 통해 "회원"이 공개를 요청한 이력서에 한해
                                            이력서 정보를 제공한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "③호" 제휴를 통한 사이트의 변동사항 발생 시 공지사항을 통해 고지 후 진행
                                            한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>부 칙</strong>
                                        </p>
                                        <p>- 본 이용약관은 공정거래위원회의 전자상거래 표준약관을 준수합니다.</p>
                                        <p>- 이 약관은 2026년 9월 1일부터 시행됩니다.</p>
                                        <br />
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="title-terms">
                                    <label className="reg__label">
                                        <input
                                            type="checkbox"
                                            name="accept-3"
                                            defaultValue="accept"
                                            className="reg__checkbox"
                                            checked={checkboxes['accept-3']}
                                            onChange={handleCheckboxChange}
                                        />
                                    </label>
                                    <p>
                                        <span className="flex">
                                            <span>이용약관동의 - DVmall</span>
                                        </span>
                                        <strong>(필수)</strong>
                                        <span className="view-more-btn" onClick={() => toggleTermsContent(2)}>
                                            <span className="star">※</span>
                                            <span>이용약관 전문보기</span>
                                        </span>
                                    </p>
                                </div>
                                <div className={`content-terms ${activeTerms[2] ? 'active' : ''}`}>
                                    <div className="contracts">
                                        <p className="mar_b10">
                                            <strong>제 1 조 (목적)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            본 약관은 주식회사 신흥(이하 "회사")이 제공하는 웹사이트(이하 "사이트")를
                                            통해 인터넷 관련 서비스(이하 "서비스")를 제공함에 있어, 사이트가 제공하는
                                            서비스와 관련하여, 이를 이용하는 이용자(이하 "회원")의 이용조건 및 제반
                                            절차, 기타 필요한 사항을 규정함을 목적으로 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 2 조 (용어의 정의)</strong>
                                        </p>
                                        <p className="mar_b5">이 약관에서 사용하는 용어의 정의는 아래와 같다.</p>
                                        <p className="mar_b5">
                                            ① "사이트"라 함은 서비스를 이용자에게 제공하기 위하여 컴퓨터 등
                                            정보통신설비를 이용하여 설정한 가상의 영업장 또는 웹사이트, 모바일웹, 앱
                                            등의 서비스를 제공하는 모든 매체를 말하며, 통합된 하나의 아이디 및
                                            비밀번호(이하 "통합계정")를 이용하여 "서비스" 를 제공받을 수 있는 아래의
                                            "사이트"로 정의한다.
                                        </p>
                                        <p>- 구인구직정보제공 : www.dentaljob.co.kr</p>
                                        <p>- 온라인정보제공 : www.dentalvitamin.com, www.dentalseminar.co.kr</p>
                                        <p>- 전자상거래(상품주문, 세미나신청) : www.dvmall.co.kr</p>
                                        <p className="mar_b5">
                                            ② "서비스"란 사이트를 통해 개인 또는 기업, 단체가 구직 또는 구인을 목적으로
                                            제공하는 자료를 DB화하여 각각의 목적에 맞게 자료를 가공, 집계하여 정보를
                                            제공하는 서비스와 취업 및 채용에 관련된 부가정보 서비스, 온라인 구매와
                                            세미나 및 이벤트, 프로모션 등의 정보제공을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "회원"이라 함은 서비스를 이용하기 위하여 동 약관에 동의하고 "사이트"와
                                            이용계약을 체결하여 이용자ID를 부여받은 개인을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "개인회원"이라 함은 구직을 목적으로 하는 개인이 본 서비스를 이용하기
                                            위하여 동 약관에 동의하고 "사이트"와 이용계약을 체결하여 이용자ID를 부여받은
                                            "회원"을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "치과회원"이라 함은 자사의 직접 고용의 목적으로 채용을 원하는 병의원
                                            단체(이하 "업체")나 구인을 목적으로 하는 개인이 본 서비스를 이용하기 위하여
                                            동 약관에 동의하고 "사이트"와 이용계약을 체결하여 이용자ID를 부여받은
                                            "회원"을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ "비회원"이라 함은 회원가입 절차를 거치지 않고 "사이트"가 제공하는 서비스를
                                            이용하거나 하려는 자를 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ "이용자"란 "사이트"가 제공하는 서비스를 받는 회원 및 비회원을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑧ "이용자ID" 또는 "회원ID"라 함은 "회원"의 식별과 "회원"의 "서비스" 이용을
                                            위하여 "회원"이 선정하고 "사이트"가 부여하는 문자와 숫자의 조합을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑨ "비밀번호"라 함은 "사이트"의 "서비스"를 이용하려는 사람이 "이용자ID"를
                                            부여받은 자와 동일인임을 확인하고 회원의 권익을 보호하기 위하여 회원이
                                            선정한 문자와 숫자의 조합을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑩ "세미나 참가비"라 함은 "사이트"에서 제공하는 세미나에 참석하는 대가로
                                            회사가 별도로 정한 요금체계에 의해 부과되는 비용을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑪ "주문"이라 함은 "사이트"에서 제공하는 서비스를 이용하기 위해 컨텐츠,
                                            재화등을 신청하는 것을 말한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 3 조 (약관의 명시와 개정)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 이 약관의 내용과 상호, 영업소 소재지, 대표자의 성명,
                                            사업자등록번호, 연락처 등을 이용자가 알 수 있도록 초기 화면에 게시하거나
                                            기타의 방법으로 이용자에게 공지해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 약관의 규제에 관한 법률, 전자거래기본법, 전자서명법,
                                            전기통신기본법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호,
                                            전자상거래등에서의 소비자보호에 관한법률 등에 관한 법률 등 관련법을 위배하지
                                            않는 범위에서 약관을 개정할 수 있으며, 변경된 약관은 "사이트" 화면에
                                            게시되거나 기타의 방법으로 "회원"에게 공지됨으로써 효력이 발생한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"가 약관을 개정할 경우 적용일자 및 개정사유를 명시하여 현행약관과
                                            함께 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지한다. 단
                                            "회원"의 권리, 의무에 중대한 영향을 주는 변경의 경우에는 적용일자 30일
                                            전부터 공지하도록 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "회원"는 변경된 약관에 대해 거부할 권리가 있다. "회원"는 변경된 약관이
                                            공지된 지 15일 이내에 거부 의사를 표명할 수 있다. "회원"가 거부하는 경우 본
                                            "서비스" 제공자인 "사이트"는 15일의 기간을 정하여 "회원"에게 사전 통지 후
                                            당해 "회원"와의 계약을 해지할 수 있다. 만약, "회원"가 거부 의사를 표시하지
                                            않고 "서비스"를 계속 이용하는 경우에는 동의하는 것으로 간주한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 4조 (약관의 해석)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 이 약관에서 규정하지 않은 사항에 관해서는 약관의 규제 등에 관한 법률,
                                            전기통신기본법, 전기통신사업법, 정보통신망이용촉진등에관한법률 등의
                                            관계법령에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 각 사이트 및 서비스 이용약관이 있는 경우에는 서비스 이용약관이 우선한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "회원"이 "사이트"와 개별 계약을 체결하여 서비스를 이용할 경우에는 개별
                                            계약이 우선한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 5 조 (이용계약의 성립)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"의 서비스 이용계약(이하 '이용계약'이라 한다)은 서비스를 이용하고자
                                            하는 자의 본 약관과 개인정보보호정책의 내용에 대한 동의 및
                                            이용신청(회원가입신청)에 대하여 "사이트"가 승낙함으로써 성립한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 서비스를 이용하고자 하는 자가 이용신청 당시 웹상의 "동의함" 버튼을 누르면
                                            본 약관 및 개인정보보호정책에 대하여 동의한 것으로 간주한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 특히 치과회원으로 가입하고자 하는 치과병의원, 기공소, 종합병원등은 국내외
                                            사업자등록증을 보유하고 있는 업체에 한해 회원 가입을 허락한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 제1항의 승낙은 이용신청자의 본 약관에 대한 동의를 확인하고 웹 상의 안내
                                            또는 전자메일로 통지함으로써 이루어지고 이러한 승낙의 통지가 이용신청자에게
                                            도달하면 이용계약이 성립한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 구인구직정보제공 사이트의 인재정보에 개인회원이 구직활동을 위해 공개한
                                            이력서정보는 열람권한을 가진 치과회원에게 제공된다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 6 조 (서비스 이용신청)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회원으로 가입하여 본 서비스를 이용하고자 하는 이용자는 "사이트"에서
                                            요청하는 제반정보(업체명, 사업자등록번호, 대표자 이름, 가입자 이름,
                                            생년월일, 전화번호, 휴대폰번호 등)를 제공하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 실명으로 등록하지 않은 사용자는 일체의 권리를 주장할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 모든 치과회원은 반드시 업체명과 사업자등록번호를 제공하여야만 서비스를
                                            이용할 수 있다. 업체명과 사업자등록번호를 허위로 등록한 경우, 휴·폐업
                                            사업자등록번호로 등록한 경우에 사용자는 일체의 권리를 주장할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 타인의 명의를 도용하여 이용신청을 한 회원의 모든 ID는 삭제되며, 관계법령에
                                            따라 처벌을 받을 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 사업자등록번호가 없는 업체, 기관이나 단체는 "사이트"가 정한 별도의 절차에
                                            따라 이용신청을 할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 회원으로 가입하더라도 로그인하지 않은 상태에서 주문하는 경우는 회원주문이
                                            아니라 비회원주문으로 인정한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 7 조 (이용신청의 승낙과 제한)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 전조의 규정에 의한 이용신청 고객에 대하여 업무수행상 또는
                                            기술상 지장이 없는 경우에는 원칙적으로 접수순서에 따라 서비스 이용을
                                            승낙한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 아래 사항에 해당하는 경우에 대해서는 이용신청을 승낙하지
                                            아니한다.
                                        </p>
                                        <p>
                                            1. 실제 업체명과 사업자등록번호가 아니거나 타사의 정보를 이용하여 신청한
                                            경우
                                        </p>
                                        <p>
                                            2. 이용계약 신청서의 내용을 허위로 기재하거나 "사이트"가 제시하는 내용을
                                            기재하지 않은 경우
                                        </p>
                                        <p>3. 본인의 생년월일이 아닌 경우</p>
                                        <p>4. 사회의 안녕 질서 또는 미풍양속을 저해할 목적으로 신청한 경우</p>
                                        <p>5. "사이트" 회원들의 보편적인 정서에 반하는 물의를 일으킨 경우</p>
                                        <p>6. "사이트"가 정한 기타 이용신청 요건에 맞지 않을 경우</p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 아래 사항에 해당하는 경우에는 그 신청에 대하여 승낙제한 사유가
                                            해소될 때까지 승낙을 유보할 수 있다.
                                        </p>
                                        <p>1. "사이트"가 설비의 여유가 없는 경우</p>
                                        <p>2. "사이트"의 기술상 지장이 있는 경우</p>
                                        <p>3. 기타 "사이트"의 귀책사유로 이용승낙이 곤란한 경우</p>
                                        <p className="mar_b5">
                                            ④ "회원"은 기재한 등록사항에 변경이 있는 경우, 즉시 전자우편 등 기타
                                            방법으로 그 변경 사항을 수정해야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 8 조 (서비스의 제공 및 변경)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 제2조 2항의 서비스를 제공할 수 있으며 그 내용은 다음 각 호와
                                            같습니다.
                                        </p>
                                        <p>1. 구인구직정보제공</p>
                                        <p>- 온라인 입사지원 서비스</p>
                                        <p>- 채용정보 등록서비스</p>
                                        <p>- 구인/구직과 관련된 제반 서비스</p>
                                        <p>- 이력서 열람 서비스</p>
                                        <p>2. 온라인정보제공</p>
                                        <p>- 뉴스레터 이메일 서비스</p>
                                        <p>- 상품 및 제품등의 프로모션 및 이벤트에 관련된 서비스</p>
                                        <p>3. 전자상거래</p>
                                        <p>- 재화등에 대한 정보 제공 및 구매계약의 체결</p>
                                        <p>- 구매계약이 체결된 재화등의 배송</p>
                                        <p>- 세미나등에 대한 정보 제공 및 신청계약의 체결</p>
                                        <p>- 신청계약이 체결된 세미나등의 제공</p>
                                        <p>4. 이용자간의 교류와 소통과 관련된 서비스</p>
                                        <p>5. 자료 거래에 관련된 서비스</p>
                                        <p>
                                            6. 기타 "사이트"가 추가 개발하거나 제휴계약 등을 통해 "회원"에게 제공하는
                                            일체의 서비스
                                        </p>
                                        <p>7. 기타 "사이트"에서 정하는 업무 및 일체의 서비스</p>
                                        <p className="mar_b5">
                                            ② "사이트"는 필요한 경우 서비스의 내용을 추가 또는 변경할 수 있다. 단, 이
                                            경우 "사이트"는 추가 또는 변경내용을 회원에게 공지해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 재화등의 품절 또는 기술적 사양의 변경 등의 경우에는 장차
                                            체결되는 계약에 의해 제공할 재화등의 내용을 변경할 수 있다. 이 경우에는
                                            변경된 재화등의 내용 및 제공일자를 명시하여 현재의 재화등의 내용을 게시한
                                            곳에 즉시 공지한다. 단, 사이트가 합리적으로 예측할 수 없는 불가피한 여건이나
                                            사정이 있는 경우, 위 공지를 하지 않을 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화등의 품절
                                            또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게
                                            통지 가능한 주소로 즉시 통지한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 9 조 (치과회원 정보, 채용공고 등록과 이력서 검색)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 치과회원은 구직을 원하는 개인회원이 채용공고를 열람한 후 해당 기업에 대한
                                            판단을 돕기 위해 기업정보를 정확히 기재하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 치과회원은 직업안정법 제34조 및 동법 시행령 제34조 거짓 구인공고의 범위에
                                            위배되지 않도록 채용공고를 작성하여 등록해야 하며 그 내용은 다음과 같다.
                                        </p>
                                        <p>
                                            1. 구인을 가장하여 물품판매, 수강생 모집, 직업소개, 부업알선, 자금모집 등을
                                            행하는 광고
                                        </p>
                                        <p>
                                            2. 허위 구인을 목적으로 구인자의 신원(업체명 또는 성명)을 표시하지 아니하는
                                            광고
                                        </p>
                                        <p>
                                            3. 구인자가 제시한 직종, 고용형태, 근로조건 등이 응모할 때의 그것과 현저히
                                            다른 광고
                                        </p>
                                        <p>4. 기타 광고의 중요내용이 사실과 다른 광고</p>
                                        <p>5. 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</p>
                                        <p>6. 공공질서 및 미풍양속에 위반되는 내용인 경우</p>
                                        <p>
                                            7. 현행법에 위배되는 내용이나 범죄적 행위에 결부된다고 인정되는 내용일 경우
                                        </p>
                                        <p>
                                            8. 사이트의 저작권 또는 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
                                        </p>
                                        <p>9. 게시판의 성격에 부합하지 않는 게시물의 경우</p>
                                        <p>
                                            10. 기타 관계 법규에 위배되는 내용이나, 사이트의 원활한 운영을 위하여
                                            운영자가 필요하다고 판단한 경우
                                        </p>
                                        <p className="mar_b5">
                                            ③ 치과회원은 남녀 고용 평등과 일, 가정 양립 지원에 관한 법률 제7조 및 관련
                                            법률에 의거하여 근로자의 모집 및 채용에 있어서 남녀, 연령을 차별하여서는
                                            아니되며 15세 미만 채용 모집을 할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 제2항, 제3항을 위반한 경우 이에 대한 책임은 전적으로 치과회원에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 치과회원이 등록한 정보 및 채용공고를 "사이트"가 정한 방법에
                                            의해 노출할 수 있으며, "사이트"가 지정한 기간이 지난 채용공고는 "사이트"가
                                            임의로 마감시킬 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 치과회원은 직원 채용의 목적으로 유·무료로 개인회원이 등록한 이력서를
                                            검색할 수 있으며 치과회원은 "사이트"가 제시하는 별도의 커뮤니케이션을 통하여
                                            개인회원에게 연락을 취할 수 있다. 단, 이력서 연락처의 열람 및 연락의 목적은
                                            직원 채용활동에 국한되어야 하며, 기업의 영업ㆍ마케팅ㆍ제3자 제공 시에는
                                            개인정보보호법, 직업안정법, 정보통신망 이용 촉진 및 정보 보호 등에 관한
                                            법률에 의거하여 법적 책임을 질 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ "사이트"는 "기업회원"이 이력서를 검색하고, "개인회원"에게 연락할 수 있는
                                            권한에 제한을 둘 수 있으며, "기업회원"이 적절하지 않은 방법으로
                                            "개인회원"에게 연락하거나, "개인회원"에게 불편을 끼친 경우, 채용공고 및
                                            회원정보를 임의로 수정/삭제할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑧ 치과회원이 자사의 직접 고용을 목적으로 하지 않는 공고를 등록할 경우
                                            "사이트"는 해당 공고를 삭제할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑨ 채용광고의 근무처 및 근무지역은 치과회원이 위치한 지역 및 근무처에 한해야
                                            한다. 본사에 지사, 지점, 영업소등을 포함하고 있는 경우는 개별 지사, 지점,
                                            영업소 단위로 채용광고를 해야 하며, 본사를 통한 일괄적인 채용광고는 할 수
                                            없다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 10 조 (개인회원 정보, 이력서 노출)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "개인회원"의 이력서는 개인이 회원가입 또는 이력서 작성 및 수정시 희망한
                                            형태로 이력서를 노출한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 개인회원이 회원정보, 이력서의 공개/비공개 지정, 이력서상의
                                            연락처 공개/비공개를 자유롭게 선택할 수 있도록 하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 개인회원이 이력서 공개를 희망했을 경우, 치과회원의 이력서
                                            열람에 동의한것으로 간주하며, "사이트"는 이들 회원에게 무료/유료로 이력서
                                            열람 서비스를 제공할 수 있다. 다만, 연락처 등 각 항목이 비공개로 지정된 경우
                                            해당 항목별 연락처를 노출할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 사이트는 개인회원이 등록한 이력서를 아이디 휴면상태 이전까지 노출할 수
                                            있으며, 사이트가 지정한 기간이 지난 이력서는 개인회원 탈퇴시 까지 관리할 수
                                            있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 안정적인 서비스를 제공하기 위해 테스트 및 모니터링 용도로
                                            "사이트" 운영자가 이력서 정보를 열람하도록 할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 11 조 (서비스의 요금)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회원 가입은 무료이며, 채용광고등록은 유료로 운영된다. 또한 개인회원 또는
                                            사이트에 방문한 회원에게 자신의 정보를 보다 효과적으로 노출시키기 위한
                                            추가적인 유료 서비스를 제공한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 유료서비스를 제공할 경우 사이트에 요금에 대해서 공지를 하여야
                                            한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 유료서비스 이용금액을 서비스의 종류 및 기간에 따라 "사이트"가
                                            예고 없이 변경할 수 있다. 다만, 변경 이전에 적용 또는 계약한 금액은 소급하여
                                            적용하지 아니한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 유료 서비스 신청 후 "회원" 사정에 의해 서비스가 취소될 경우, 정부가
                                            고시하는 '디지털콘텐츠 이용자보호지침'에 따라 "사이트"는 본 지침이 제시하는
                                            범위 내에서 환불 수수료를 부과할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 12 조 (서비스 이용시간)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 특별한 사유가 없는 한 연중무휴, 1일 24시간 서비스를 제공한다.
                                            다만, "사이트"는 서비스의 종류나 성질에 따라 제공하는 서비스 중 일부에
                                            대해서는 별도로 이용시간을 정할 수 있으며, 이 경우 "사이트"는 그 이용시간을
                                            사전에 회원에게 공지 또는 통지하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 자료의 가공과 갱신을 위한 시스템 작업시간, 장애해결을 위한
                                            보수작업 시간, 정기 PM작업, 시스템 교체작업, 회선 장애 등이 발생한 경우
                                            일시적으로 서비스를 중단할 수 있으며 계획된 작업의 경우 공지란에 서비스 중단
                                            시간과 작업 내용을 알려야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 13 조 (서비스 제공의 중지)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 다음 각 호에 해당하는 경우 서비스의 제공을 중지할 수 있다.
                                        </p>
                                        <p>1. 설비의 보수 등 "사이트"의 필요에 의해 사전에 회원들에게 통지한 경우</p>
                                        <p>2. 기간통신사업자가 전기통신서비스 제공을 중지하는 경우</p>
                                        <p>3. 기타 불가항력적인 사유에 의해 서비스 제공이 객관적으로 불가능한 경우</p>
                                        <p className="mar_b5">
                                            ② 전항의 경우, "사이트"는 기간의 정함이 있는 유료서비스 이용자들에게는 그
                                            이용기간을 연장하는 등의 방법으로 손실을 보상하여야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 14 조 (정보의 제공 및 광고의 게재)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 회원에게 서비스 이용에 필요가 있다고 인정되거나 서비스 개선 및
                                            회원대상의 서비스 소개 등의 목적으로 하는 각종 정보에 대해서 전자우편이나
                                            서신우편을 이용한 방법으로 제공할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 제공하는 서비스와 관련되는 정보 또는 광고를 서비스 화면,
                                            홈페이지 등에 게재할 수 있으며, 회원들에게 메일을 통해 알릴 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 서비스상에 게재되어 있거나 본 서비스를 통한 광고주의 판촉활동에
                                            회원이 참여하거나 교신 또는 거래를 함으로써 발생하는 모든 손실과 손해에 대해
                                            책임을 지지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 본 서비스의 회원은 서비스 이용 시 노출되는 광고게재에 대해 동의 하는
                                            것으로 간주한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 15 조 (자료내용의 책임과 "사이트"의 정보 수정 권한)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 자료내용은 회원이 등록한 업체정보, 채용공고, 이력서정보 및 사이트에 게시한
                                            게시물을 말한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회원은 자료 내용 및 게시물을 사실에 근거하여 성실하게 작성해야 하며, 만일
                                            자료의 내용이 사실이 아니거나 부정확하게 작성되어 발생하는 모든 책임은
                                            회원에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 모든 자료내용의 관리와 작성은 회원 본인이 하는 것이 원칙이나 사정상 위탁
                                            또는 대행관리를 하더라도 자료내용의 책임은 회원에게 있으며 회원은 주기적으로
                                            자신의 자료를 확인하여 항상 정확하게 관리가 되도록 노력해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 회원이 등록한 자료 내용에 오자, 탈자 또는 사회적 통념에
                                            어긋나는 문구와 내용이 있을 경우 이를 언제든지 수정할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 "회원"이 등록한 자료를 "사이트"가 운영하는 같은 목적의 타
                                            "사이트"에도 게재할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ "회원"이 등록한 자료로 인하여 타인(또는 타법인)으로부터 허위사실 및
                                            명예훼손 등으로 삭제요청이 접수된 경우 "사이트"는 "회원"에게 사전 통지 없이
                                            본 자료를 삭제할 수 있으며, 자료 삭제후 메일 등의 방법으로 "회원"에게 통지할
                                            수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ "사이트"는 다음 각 호에 해당하는 경우 회원의 동의를 받아 회원이 신청한
                                            정보를 변경할 수 있다.
                                        </p>
                                        <p>
                                            - 아이디가 회원의 전화번호, 생년월일 등으로 등록되어 있어서 회원의 사생활을
                                            침해할 우려가 있는 경우
                                        </p>
                                        <p>- 고객센터문의, 이메일 등의 방법을 통해 변경요청하는 경우</p>
                                        <p>- 기타 "사이트"의 기술상 현저히 지장이 있다고 판단되는 경우</p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 16 조 (회사의 의무)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회사는 본 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 수
                                            있도록 최선의 노력을 다해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회사는 서비스와 관련한 회원의 불만사항이 접수되는 경우 이를 즉시
                                            처리하여야 하며, 즉시 처리가 곤란한 경우에는 그 사유와 처리일정을 서비스
                                            화면 또는 기타 방법을 통해 동 회원에게 통지하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 회사는 유료 결제와 관련한 결제 사항 정보를 1년 이상 보존한다. 다만 회원
                                            자격이 없는 회원은 예외로 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 천재지변 등 예측하지 못한 일이 발생하거나 시스템의 장애가 발생하여
                                            서비스가 중단될 경우 이에 대한 손해에 대해서는 회사가 책임을 지지 않는다.
                                            다만 자료의 복구나 정상적인 서비스 지원이 되도록 최선을 다할 의무를 진다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 회원의 자료를 본 서비스 이외의 목적으로 제3자에게 제공하거나 열람시킬 경우
                                            반드시 회원의 동의를 얻어야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 치과회원이 사이트에 등록한 치과정보, 채용공고 내용은 사이트를 방문하는
                                            일반 대중에게 공개함을 원칙으로 하며 회사는 공개 기간을 지정할 수 있다. 단,
                                            일부 비공개 항목은 회사에서 제시하는 별도의 옵션을 통해 지정할 수 있으며,
                                            회사는 이 항목에 대한 비공개 의무를 진다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ 구직자의 정보의 정확성은 구인자가 직접 확인하여야 하며 회사는 이와
                                            관련하여 어떠한 책임도 지지 아니한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 17 조 (회원의 의무)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 회원은 관계법령과 본 약관의 규정 및 기타 "사이트"가 통지하는 사항을
                                            준수하여야 하며, 기타 "사이트"의 업무에 방해되는 행위를 해서는 안된다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회원이 신청한 유료서비스는 등록 또는 신청과 동시에 "사이트"와 채권, 채무
                                            관계가 발생하며, 회원은 이에 대한 요금을 지정한 기일 내에 납부하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 회원이 결제 수단으로 신용카드를 사용할 경우 비밀번호 등 정보 유실 방지는
                                            회원 스스로 관리해야 한다. 단, 사이트의 결함에 따른 정보유실의 발생에 대한
                                            책임은 회원의 의무에 해당하지 아니한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 회원은 서비스를 이용하여 얻은 정보를 "사이트"의 사전동의 없이 복사, 복제,
                                            번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 회원은 본 서비스를 건전한 직원채용 이외의 목적으로 목적으로 사용해서는
                                            안되며 이용 중 다음 각 호의행위를 해서는 안된다.
                                        </p>
                                        <p>1. 다른 회원의 아이디를 부정 사용하는 행위</p>
                                        <p>2. 범죄행위을 목적으로 하거나 기타 범죄행위와 관련된 행위</p>
                                        <p>3. 타인의 명예를 훼손하거나 모욕하는 행위</p>
                                        <p>4. 타인의 지적재산권 등의 권리를 침해하는 행위</p>
                                        <p>5. 해킹행위 또는 바이러스의 유포 행위</p>
                                        <p>
                                            6. 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 계속적으로 전송하는
                                            행위
                                        </p>
                                        <p>7. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있다고 판단되는 행위</p>
                                        <p>8. 사이트의 정보 및 서비스를 이용한 영리 행위</p>
                                        <p>9. 그밖에 선량한 풍속, 기타 사회질서를 해하거나 관계법령에 위반하는 행위</p>
                                        <p className="mar_b5">
                                            ⑥ 치과회원은 "사이트"를 통해 열람한 이력서 정보를 "사이트" 및 당사자의
                                            허락없이 재배포할 수 없으며 본 정보에 대한 출력 및 복사 등의 관리 책임은
                                            전적으로 치과회원에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑦ 아이디(ID)와 비밀번호의 관리에 대한 책임은 "회원"에게 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑧ "회원"은 자신의 아이디(ID)를 타인에게 양도, 증여할 수 없다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑨ 자신의 아이디(ID)가 부정하게 사용된 경우, "회원"은 반드시 "사이트"에 그
                                            사실을 통보해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑩ "회원"은 본 "사이트"에 규정한 제반 준수 사항을 바탕으로 회원의 신용을
                                            평가받게 된다.
                                        </p>
                                        <p className="mar_b5">⑪ 자료 공개 방식은 스스로 결정해서 관리한다.</p>
                                        <p className="mar_b5">
                                            ⑫ "회원"은 자신의 비밀번호를 분실한 경우 임시비밀번호를 발급받아 새로운
                                            비밀번호로 변경해야 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 18 조 (회원의 가입해지/서비스중지/자료삭제)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "회원"은 언제든지 회원탈퇴 또는 채용공고 등록을 해지하기 위해 고객센터
                                            또는 회원탈퇴 메뉴 등을 통하여 이용계약 해지 신청을 할 수 있으며,
                                            가입해지시는 해지사유를 밝혀야 한다. 또한 "사이트"는 관련법 등이 정하는 바에
                                            따라 이를 처리해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 다음의 사항에 해당하는 경우 "사이트"는 사전 동의없이 가입해지나 서비스
                                            중지, 채용공고 삭제 조치를 취할 수 있다.
                                        </p>
                                        <p>1. 회원의 의무를 성실하게 이행하지 않았을 때</p>
                                        <p>2. 규정한 유료서비스 이용 요금을 납부하지 않았을 때</p>
                                        <p>3. 불순한 의도로 유료서비스를 반복적으로 결제/취소할 때</p>
                                        <p>
                                            4. 본 서비스 목적에 맞지 않는 분야에 정보를 활용하여 사회적 물의가 발생한 때
                                        </p>
                                        <p>5. 회원이 등록한 정보의 내용이 사실과 다르거나 조작되었을 때</p>
                                        <p>6. 사업자등록증에 나타난 정보와 기업회원 가입시의 정보가 일치하지 않을 때</p>
                                        <p>
                                            7. 타 기업의 사업자등록번호나 상호를 도용하여 허위로 기업정보를 등록하거나
                                            휴·폐업 사업자등록번호로 기업정보를 등록했을 때
                                        </p>
                                        <p>
                                            8. 지사, 지점, 영업소 등의 경우 구체적인 지사, 지점, 영업소 명칭을 사용하지
                                            않고 기업명을 등록했거나 지사, 지점, 영업소의 사업자등록번호가 별도 있음에도
                                            불구하고 본사의 사업자등록번호로 기업회원 가입을 했을 때
                                        </p>
                                        <p>
                                            9. 사이트명, 담당자 성명, 사무실 연락처 등 구인업체의 중요 정보를 정확하게
                                            기입하지 않았을 때
                                        </p>
                                        <p>
                                            10. 치과회원 가입 또는 채용공고 등록시 본 서비스에서 안내하는 방법으로
                                            가입하지 않았거나 등록하지 않았을 때
                                        </p>
                                        <p>11. 동일 회원 ID로 게재 중인 동일 내용 채용공고를 중복 등록했을 때</p>
                                        <p>12. 동일 사업자가 특별한 이유 없이 중복 가입했을 때</p>
                                        <p>
                                            13. 동일 사업자가 마감일이 지나지 않은 사실상의 동일내용의 채용공고를 다수
                                            ID를 사용하여 중복등록 했을 때
                                        </p>
                                        <p>14. 허위 구인공고를 등록했을 때</p>
                                        <p>15. 작성자가 제시한 직종, 업무내용, 근로조건 등이 실제와 현저히 다를 때</p>
                                        <p>16. 채용공고의 모집요강만으로 업무에 대한 내용이 명확하지 않을 때</p>
                                        <p>17. 모집요강에 적합한 업직종 분류를 지정하지 않았을 때</p>
                                        <p>
                                            (특히, 교육기관이나 이벤트업체 또는 영업대행기관의 경우 영업, 마케팅,
                                            텔레마케팅, 상담인력을 모집하고자 할 경우 반드시 텔레마케팅 또는 고객상담,
                                            교육/강사/학원등 반드시 직접 관련되는 해당 업종, 직종분류만 지정해야 한다.)
                                        </p>
                                        <p>18. 다단계, 피라미드 식의 모집 내용을 등록했을 때</p>
                                        <p>
                                            19. 구인을 가장하여 유학알선, 물품판매, 자금 모금 등을 행하는 내용을
                                            등록했을 때
                                        </p>
                                        <p>20. 교육비, 수강료를 요구하는 수강생 모집광고, 학원 광고를 등록했을 때</p>
                                        <p>
                                            21. 회원모집 형태의 광고 또는 카드회원 모집(수당제 광고) 내용을 등록했을 때
                                        </p>
                                        <p>
                                            22. 추천인 모집 광고, 재택 쇼핑몰 분양 광고, 직업소개, 부업알선 광고를
                                            등록했을 때
                                        </p>
                                        <p>
                                            23. 취업수수료 등 취업 관련 비용을 필요로 하는 채용공고를 등록했을 때 (운송,
                                            물류, 지입, 인력용역 등)
                                        </p>
                                        <p>24. 불건전한 내용의 유흥업소 채용공고를 등록했을 때</p>
                                        <p>
                                            25. 구직자의 피해사례가 (채용공고를 통해 구직자가 입사 과정에서 피해가
                                            발생한 경우 또는 재직중 "치과회원"이 관계법령을 위반하여 피해가 발생한 경우
                                            등)가 접수된 채용공고
                                        </p>
                                        <p>26. 임금체불 사실이 접수되었거나 근로감독원에 진정서가 접수되어 있는 기업</p>
                                        <p>
                                            27. 사업자 모집, 프랜차이즈 모집, 점포개설, 창업 등 직원 채용이 아닌 공고를
                                            등록했을때
                                        </p>
                                        <p>
                                            28. 메일이나 문자메시지 수신자가 스팸으로 신고하거나 회원이 발송하는
                                            메시지가 불법 스팸임이 판명될 경우
                                        </p>
                                        <p>
                                            29. 방송통신위원회 또는 한국정보보호진흥원이 불법 스팸 전송 사실을 확인하여
                                            이용 정지를 요청하는 경우
                                        </p>
                                        <p>
                                            30. 미래창조과학부(거짓으로 표시된 전화번호로 인한 이용자 피해 예방에 관한)
                                            고시 제2015-32호 제10조 제1항에 따라 미래창조과학부 또는 중앙전파관리소,
                                            한국 인터넷진흥원(KISA)에서 번호 변작 등으로 판명되어 이용 정지를 요청한
                                            경우
                                        </p>
                                        <p>31. 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</p>
                                        <p>
                                            32. 사이트의 저작권 또는 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
                                        </p>
                                        <p>33. 게시판의 성격에 부합하지 않는 게시물의 경우</p>
                                        <p>34. 공공질서 및 미풍양속에 위반되는 내용인 경우</p>
                                        <p>35. 회원들의 보편적인 정서에 반하는 물의를 일으킨 경우</p>
                                        <p>
                                            36. 기타 관계법규에 위배되는 내용이거나 사이트의 원활한 운영을 위하여
                                            운영자가 필요하다고 판단한 경우
                                        </p>
                                        <p>
                                            37. 기타 본 서비스 명예를 훼손하였거나 사이트가 판단하기에 적합하지 않은
                                            목적으로 회원가입을 하였을 때
                                        </p>
                                        <p>
                                            38. "회원"으로 등록하는 것이 "사이트"의 기술상 현저히 지장이 있다고 판단되는
                                            경우
                                        </p>
                                        <p className="mar_b5">
                                            ③ 회원이 유료서비스를 이용하는 중 "사이트"의 책임에 의해 정상적인 서비스가
                                            제공되지 않을 경우 회원은 본 서비스의 해지를 요청할 수 있으며 "사이트"는
                                            기간의 정함이 있는 유료서비스의 경우에는 해지일까지 이용일수를 1일
                                            기준금액으로 계산하여 이용금액을 공제후 환급하고, 이용건수의 정함이 있는
                                            유료서비스의 경우에는 기 사용분을 1건 기준금액으로 계산하여 이용금액을
                                            공제후 환급하거나 기간연장등의 방법으로 보상합니다. 단, 허위·불량공고의 경우
                                            게재시 지불된 광고료는 일체 반환되지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 회원 가입이 해지된 경우 해당 회원 정보를 모두 삭제하여야 하며,
                                            상법, 전자상거래등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여
                                            보존할 필요가 있는 경우 관계법령에서 정한 일정한 기간 동안 회원정보를
                                            보관한다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 1년이상 "회원"의 관리 없이 방치되고 있다고 판단되는 "회원"의
                                            자료는 임의로 삭제할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ 개인정보보호를 위하여 "회원"이 선택한 개인정보 보유기간(1년) 동안
                                            "사이트"를 이용하지 않은 경우, "아이디"를 "휴면계정"으로 분리하여 해당
                                            계정의 이용을 중지할 수 있다. 이 경우 "사이트"는 "휴면계정 처리
                                            예정일"로부터 30일 이전에 해당사실을 전자메일, 서면, SMS 중 하나의 방법으로
                                            사전통지하며 "회원"이 직접 본인확인을 거쳐, 다시 "사이트" 이용 의사표시를 한
                                            경우에는 "사이트" 이용이 가능하다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 19 조 (허위 구인광고 경고)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            허위 구인광고로 인해 발생된 문제에 따른 법적인 책임은 모두 작성자에게
                                            있으며, 구인광고 게재시에 지불된 광고료는 일체 반환되지 않습니다. 허위
                                            구인광고 또는 허위 구인 조건을 제시한 자는 직업 안정법 제 47조에 의해 5년
                                            이하의 징역 또는 2천만원 이하의 벌금형을 받게 된다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 20 조 (손해배상)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"가 이 약관의 제8조, 제16조, 제18조 등의 규정에 위반한 행위로
                                            이용자에게 손해를 입히거나 기타 "사이트"가 제공하는 모든 서비스와 관련하여
                                            "사이트"의 책임 있는 사유로 인해 이용자에게 손해가 발생한 경우 "사이트"는 그
                                            손해를 배상하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 회원이 이 약관의 제6조, 제17조, 제18조 등의 규정에 위반한 행위로 "사이트"
                                            및 제3자에게 손해를 입히거나 회원의 책임 있는 사유에 의해 "사이트" 및
                                            제3자에게 손해를 입힌 경우에는 회원은 그 손해를 배상하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 "서비스" 이용과 관련하여 "회원"에게 발생한 손해 가운데 "회원"의
                                            고의, 과실 및 "회원"의 귀책사유로 인한 "서비스" 이용의 장애 및 손해에
                                            대하여는 책임을 지지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 "회원"이 "서비스"를 이용하여 기대하는 수익을 얻지 못하거나
                                            상실한 것에 대하여 책임을 지지 않으며, "사이트"가 무료로 제공하는 "서비스"의
                                            이용과 관련하여 개인정보 처리방침에서 정하는 내용에 위반하지 않은 한 어떠한
                                            손해도 책임지지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ "사이트"는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할
                                            수 없는 경우 "서비스" 제공에 관한 책임이 면제된다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 21 조 (이용요금 오류의 조정)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            "사이트"는 이용요금과 관련하여 오류가 있는 경우에 이용자의 요청, 또는
                                            "사이트"의 사전 통지에 의하여 다음에 해당하는 조치를 취한다.
                                        </p>
                                        <p className="mar_b5">
                                            ① 과다납입한 요금에 대하여는 그 금액을 반환하거나 이용기간을 조정한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 요금을 반환받아야 할 이용자가 요금체납이 있는 경우에는 반환해야 할
                                            요금에서 이를 우선 공제하고 반환한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 과소청구액에 대해서는 익월에 합산청구한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 22 조 (회원의 개인정보보호)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            "사이트"는 이용자의 개인정보보호를 위하여 노력해야 한다. 이용자의
                                            개인정보보호에 관해서는 정보통신망이용촉진 및 정보보호 등에 관한 법률에
                                            따르고, 사이트에 "개인정보취급방침"을 고지한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 23조 (신용정보의 제공 활용 동의)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"가 회원가입과 관련하여 취득한 "회원"의 신용 정보를 타인에게
                                            제공하거나 활용하고자 할 때에는 신용 정보의 이용 및 보호에 관한 법률
                                            제32조의 규정에 따라 사전에 그 사유 및 해당기관 또는 업체명 등을 밝히고 해당
                                            "회원"의 동의를 얻어야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 본 "서비스"와 관련하여 "사이트"가 "회원"으로부터 신용 정보 이용 및 보호에
                                            관한 법률에 따라 타인에게 정보제공 활용에 동의를 얻은 경우 "회원"은
                                            "사이트"가 신용 정보 사업자 또는 신용 정보 집중기관에 정보를 제공하여
                                            "회원"의 신용을 판단하기 위한 자료로 활용하거나, 공공기관에서 정책자료로
                                            활용되도록 정보를 제공하는 데 동의한 것으로 간주한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 24 조 (분쟁의 해결)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"와 회원은 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여
                                            필요한 모든 노력을 하여야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 전항의 노력에도 불구하고, 동 분쟁에 관한 소송은 "사이트"의 주소지
                                            관할법원으로 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 25 조 (자료 내용의 활용 및 온라인 입사 지원 정보)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "치과회원"이 입력한 정보는 채용 및 고용동향 통계 자료로 활용될 수 있으며
                                            채용공고는 매체를 통해 언론에 배포될 수 있다. 단, 활용되는 정보 중 개인을
                                            식별할 수 있는 정보는 제외된다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 "사이트"의 온라인 입사 지원 시스템을 통해 지원한 "개인회원"이
                                            자신의 이력서 열람 여부 및 지원자 통계 자료를 "개인회원"에게 제공할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"가 작성한 게시물 또는 저작물에 대한 저작권 및 기타 지적 재산권은
                                            "사이트"에 귀속한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "회원"이 "사이트" 내에 게시한 게시물의 저작권은 "회원"에게 귀속된다. 단,
                                            "회원"은 자신이 창작, 등록한 게시물에 대해 무상의 비독점적 사용권을
                                            "사이트"에 부여하고, 이 사용권은 "사이트"가 "사이트"를 운영하는 동안 계속
                                            유효하며, "회원" 탈퇴한 후에도 이와 같다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑤ 게시물에 대한 권리와 책임은 게시물을 게시한 "회원"에게 있으며, "사이트"는
                                            "회원"의 동의 없이 이를 "사이트"가 운영하는 "사이트" 이외에 영리적 목적으로
                                            사용할 수 없다. 단, 비영리적인 경우에는 해당되지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ⑥ "사이트"에서 정당한 절차를 거쳐 "치과회원"이 열람한 개인 "회원"의 이력서
                                            정보는 해당 업체의 인사 자료이며, 이에 대한 관리 권한은 해당 업체의 정책에
                                            따른다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 26 조 (전자상거래 사이트에서의 구매 및 이용신청)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "이용자"는 전자상거래 "사이트"상에서 다음 또는 이와 유사한 방법에 의하여
                                            구매를 신청하며, 전자상거래 "사이트"는 이용자가 구매신청을 함에 있어서
                                            다음의 각 내용을 알기 쉽게 제공하여야 한다. 단, 회원인 경우 제2호 내지
                                            제4호의 적용을 제외할 수 있다.
                                        </p>
                                        <p>1. 재화등의 검색 및 선택</p>
                                        <p>
                                            2. 성명, 주소, 연락처(전화번호/핸드폰/이메일), 배송정보(수취인, 주소,
                                            연락처) 등의 입력
                                        </p>
                                        <p>
                                            3. 약관내용, 청약철회권이 제한되는 서비스, 배송료,설치비 등의 비용부담과
                                            관련한 내용에 대한 확인
                                        </p>
                                        <p>
                                            4. 약관에 동의하고 위 3호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)
                                        </p>
                                        <p>
                                            5. 재화등의 구매신청 및 이에 관한 확인 또는 전자상거래 "사이트"의 확인에
                                            대한 동의
                                        </p>
                                        <p>6. 결제방법의 선택</p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 27 조 (전자상거래 사이트에서의 지급방법과 시기)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"에서 구매한 재화등에 대한 대금지급방법은 다음 각 호의
                                            방법중 가용한 방법으로 할 수 있다. 단, 전자상거래 "사이트"은 이용자의
                                            지급방법에 대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수
                                            없으며, 현재 서비스 중인 것으로만 한다.
                                        </p>
                                        <p>1. 폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체</p>
                                        <p>2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제</p>
                                        <p>3. 온라인무통장입금</p>
                                        <p>4. 전자화폐에 의한 결제</p>
                                        <p>
                                            5. 마일리지, 포인트 등 "사이트" 또는 전자상거래 "사이트"가 지급한 수단에
                                            의한 결제
                                        </p>
                                        <p>
                                            6. 전자상거래 "사이트"와 계약을 맺었거나 전자상거래 "사이트"가 인정한
                                            상품권에 의한 결제
                                        </p>
                                        <p>7. 기타 전자상거래 "사이트"에서 정하는 통상적인 방법의 대금결제 등</p>
                                        <p className="mar_b5">
                                            ② 전자상거래 "사이트"에서 구매한 재화등 온라인 구매에 대한 대금지급시기는 그
                                            신청일로부터 7일이내로 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 전자상거래 "사이트"에서 서비스하는 세미나 신청의 대금지급시기는 전자상거래
                                            "사이트"에서 정한 마감일까지로 한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>
                                                제 28 조 (전자상거래 사이트에서의 수신확인통지,구매신청 변경 및 취소)
                                            </strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"는 이용자의 구매신청이 있는 경우 이용자에게
                                            수신확인통지를 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 수신확인통지를 받은 이용자는 의사표시의 불일치등이 있는 경우에는 수신확인
                                            통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 전자상거래
                                            "사이트"는 배송전에 이용자의 요청이 있는 경우에는 지체없이 그 요청에 따라
                                            처리하여야 한다. 다만 이미 대금을 지불한 경우에는 제29조의 청약철회 등에
                                            관한 규정에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 전자상거래 "사이트"에서 제공하는 세미나 서비스를 신청한 이용자 중 이미
                                            대금을 지불한 경우 제 15 조의 청약철회 등에 관한 규정에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 전자상거래 "사이트"은 이용자가 구매(주문)신청 후 제27조에 의한
                                            지급방법으로 그 신청일로부터 7일 이내 또는 전자상거래 "사이트"에서 정한
                                            마감일까지 상품(이용)대금에 대해 입금이 확인되지 않을 경우 전자상거래
                                            "사이트"는 별도 의사 표시 없이 구매계약을 해제하는 것으로 처리할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 29 조 (전자상거래 사이트에서의 청약철회 등)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"와 재화등의 구매에 관한 계약을 체결한 이용자는
                                            수신확인의 통지를 받은 날부터 7일 이내에는 청약의 철회를 할 수 있다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 이용자는 재화등을 배송받은 경우 다음 각 호의 1에 해당하는 경우에는 반품 및
                                            교환등 청약철회를 할 수 없다.
                                        </p>
                                        <p>
                                            1. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우 (다만, 재화
                                            등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수
                                            있다.)
                                        </p>
                                        <p>
                                            2. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우
                                        </p>
                                        <p>
                                            3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화등의 가치가 현저히 감소한
                                            경우
                                        </p>
                                        <p>
                                            4. 같은 성능을 지닌 재화등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을
                                            훼손한 경우
                                        </p>
                                        <p>
                                            5. 전자상거래 "사이트"에서 제공하는 세미나를 신청, 대금 지급 후 적절한
                                            철회의사를 세미나 시작후 2일이내까지 표시하지 않은 경우
                                        </p>
                                        <p>
                                            6. 전자상거래 "사이트"에서 제공하는 세미나를 신청, 대금 지급 후 해당
                                            세미나에 참석확인이 된 경우
                                        </p>
                                        <p className="mar_b5">
                                            ③ 제②항 제2호 내지 제4호의 경우에 전자상거래 "사이트"이 사전에 청약철회 등이
                                            제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나 시용상품을 제공하는
                                            등의 조치를 하지 않았다면 이용자의 청약철회등이 제한되지 않는다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 이용자는 제①항 및 제②항의 규정에 불구하고 재화등의 내용이 표시·광고 내용과
                                            다르거나 계약내용과 다르게 이행된 때에는 당해 재화등을 공급받은 날부터
                                            3월이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을
                                            할 수 있다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 30 조 (전자상거래 사이트에서의 청약철회 등의 효과)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"는 이용자로부터 재화 등을 반환받은 경우 5영업일 이내에
                                            이미 지급받은 재화등의 대금을 환급한다. 이 경우 전자상거래 "사이트"가
                                            이용자에게 재화등의 환급을 지연한 때에는 그 지연기간에 대하여
                                            공정거래위원회가 정하여 고시하는 지연이자율을 곱하여 산정한 지연이자를
                                            지급합니다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 전자상거래 "사이트"는 위 대금을 환급함에 있어서 이용자가 신용카드 또는
                                            전자화폐 등의 결제수단으로 재화등의 대금을 지급한 때에는 지체없이 당해
                                            결제수단을 제공한 사업자로 하여금 재화등의 대금의 청구를 정지 또는
                                            취소하도록 요청한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 청약철회등의 경우 공급받은 재화등의 반환에 필요한 비용은 이용자가
                                            부담한다. 전자상거래 "사이트"은 이용자에게 청약철회등을 이유로 위약금 또는
                                            손해배상을 청구하지 않는다. 다만 재화등의 내용이 표시·광고 내용과 다르거나
                                            계약내용과 다르게 이행되어 청약철회등을 하는 경우 재화등의 반환에 필요한
                                            비용은 전자상거래 "사이트"가 부담한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ 이용자가 재화등을 제공받을때 발송비를 부담한 경우에 전자상거래 "사이트"은
                                            청약철회시 그 비용을 누가 부담하는지를 이용자가 알기 쉽도록 명확하게
                                            표시한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 31 조 (전자상거래 사이트에서의 환급)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① 전자상거래 "사이트"는 이용자가 구매신청한 재화등이 품절 등의 사유로 인도
                                            또는 제공을 할 수 없을 때에는 지체없이 그 사유를 이용자에게 통지하고 사전에
                                            재화 등의 대금을 받은 경우에는 대금을 받은 날부터 5영업일 이내에, 그렇지
                                            않은 경우에는 그 사유 발생일로부터 5영업일 이내에 계약해제 및 환급절차를
                                            취한다.
                                        </p>
                                        <p className="mar_b5">
                                            ② 전자상거래 "사이트"에서 제공하는 세미나 서비스인 경우는 세미나
                                            시작전일까지 철회의사를 표시한 회원에게만 환급절차를 취한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ 제②항의 규정에 따라 세미나 시작전일까지 철회의사를 표시한 경우는 환급에
                                            소요되는 필요한 경비는 전자상거래 "사이트"에서 부담하나, 세미나 시작후
                                            2일이내에 철회의사를 표시한 경우는 환급에 소요되는 필요한 경비는 이용자가
                                            부담합니다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 32 조 (서비스 환불)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 원칙적으로 "서비스" 이용료를 환불하지 않는다. 특히, 다음 각
                                            호의 경우는 이용료 환불 불가 외에 다른 제재 조치를 취할 수 있다.
                                        </p>
                                        <p>1. 회원이 서비스 이용규정 위반이 명백한 경우</p>
                                        <p>
                                            2. 치과회원 약관 제18조에 의거 회원이 불량 공고를 등록하고 유료 서비스를
                                            신청한 경우
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 다음 각 호에 경우에는 이용료를 환불할 수 있다.
                                        </p>
                                        <p>1. 유료 서비스 이용이 개시되지 않은 경우</p>
                                        <p>2. 네트워크 또는 시스템 장애로 서비스 이용이 불가능한 경우</p>
                                        <p className="mar_b5">
                                            ③ 이용료를 환불받고자 하는 "회원"은 "사이트"에 유선 상의 방법으로 환불을
                                            요청해야 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "사이트"는 "회원"으로부터 전항의 요청을 받는 즉시 사실 확인 후, 환불
                                            요건에 부합하는 경우 정당한 사유 없이 이용료 환불을 거부할 수 없다.
                                        </p>
                                        <p className="mar_b5">⑤ 전자상거래 "사이트"를 이용한 경우는 제 31조를 따른다</p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>제 32 조 (제휴를 통한 서비스)</strong>
                                        </p>
                                        <p className="mar_b5">
                                            ① "사이트"는 제휴 관계를 체결한 여타 인터넷 웹 사이트 및 신문, 잡지 등의
                                            오프라인 매체를 통해 사이트에 등록한 "회원"의 이력서 정보가 열람될 수 있도록
                                            서비스를 제공할 수 있다. 단, 제휴 서비스를 통해 노출되는 이력서의 연락처
                                            정보는 제10조의 각 항에 따른다.
                                        </p>
                                        <p className="mar_b5">
                                            ② "사이트"는 제휴를 통해 타 사이트 및 매체에 등록될 수 있음을 고지해야 하며,
                                            제휴 사이트 목록을 사이트내에서 상시 열람할 수 있도록 해야 한다. 단, 등록의
                                            형태가 "사이트"가 직접 구축하지 않고, 제휴사가 xml 또는 api 형태로
                                            "사이트"로부터 제공 받아 구축한 매체 목록은 본 약관외 별도의 제휴리스트에서
                                            열람할 수 있도록 한다.
                                        </p>
                                        <p className="mar_b5">
                                            ③ "사이트"는 사이트와 제휴를 통해 "회원"이 공개를 요청한 이력서에 한해
                                            이력서 정보를 제공한다.
                                        </p>
                                        <p className="mar_b5">
                                            ④ "③호" 제휴를 통한 사이트의 변동사항 발생 시 공지사항을 통해 고지 후 진행
                                            한다.
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>부 칙</strong>
                                        </p>
                                        <p>- 본 이용약관은 공정거래위원회의 전자상거래 표준약관을 준수합니다.</p>
                                        <p>- 이 약관은 2026년 9월 1일부터 시행됩니다.</p>
                                        <br />
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="title-terms">
                                    <label className="reg__label">
                                        <input
                                            type="checkbox"
                                            name="accept-4"
                                            defaultValue="accept"
                                            className="reg__checkbox"
                                            checked={checkboxes['accept-4']}
                                            onChange={handleCheckboxChange}
                                        />
                                    </label>
                                    <p>
                                        <span className="flex">
                                            <span>개인정보 수집 및 이용에 대한 안내</span>
                                        </span>
                                        <strong>(필수)</strong>
                                        <span className="view-more-btn" onClick={() => toggleTermsContent(3)}>
                                            <span className="star">※</span>
                                            <span>개인정보 처리방침 전문보기</span>
                                        </span>
                                    </p>
                                </div>
                                <div className={`content-terms ${activeTerms[3] ? 'active' : ''}`}>
                                    <div className="contracts privacys">
                                        <p className="mar_b10">
                                            <strong>1. 개인정보 수집 및 이용 현황</strong>
                                        </p>
                                        <p className="mar_b5">
                                            사이트의 서비스 제공을 위한 최소한의 범위 내에서 이용자의 동의 하에
                                            개인정보를 수집하며, 수집한 모든 개인정보는 고지한 목적 범위 내에서만
                                            사용됩니다. 또한, 제공하는 서비스(채용 정보제공 등) 특성상 「근로기준법」에
                                            따라 만15세 미만인 경우 회원가입을 허용하지 않습니다. 사이트에서 제공하는
                                            서비스 유형에 따라 다음과 같이 개인정보를 수집, 이용, 보유 및 파기하고
                                            있습니다.
                                        </p>
                                        <p className="mar_b5">가. 수집하는 개인정보의 항목</p>
                                        <p className="mar_b5">1) 회원가입</p>
                                        <p>
                                            - 필수항목 : 아이디, 비밀번호, 본인인증정보 또는 중복가입확인정보(CI,DI),
                                            이름, 생년월일, 회원구분, 면허자격번호, 근무처명, 사업자등록번호,
                                            연락처(전화번호/휴대폰/이메일), 주소
                                        </p>
                                        <p>- 선택항목 : 마케팅정보 수신동의(이메일, SMS)</p>
                                        <p>
                                            - 수집 및 이용목적 : 본인 확인 및 가입의사 확인, 상담 및 문의처리, 회원
                                            맞춤형 채용정보 제공, 새로운 정보의 소개 및 고지사항 전달, 신규 서비스 안내,
                                            설문, 이벤트 관련 정보 및 참여 기회 제공, 광고 및 마케팅 정보 제공
                                        </p>
                                        <p className="pad_t5 mar_b5">2) 이력서 등록</p>
                                        <p>
                                            - 필수항목 : 기본정보(이름, 연락처(전화번호/휴대폰/이메일)), 근무요건(업무,
                                            자격증, 근무형태, 지역, 급여), 학력, 경력
                                        </p>
                                        <p>
                                            - 선택항목 : 홈페이지, 직급, 근무요건(기간,요일,시간,경험)(알바), 학력기타,
                                            상세경력(근무기간, 사업장명, 근무지역, 직급, 담당업무, 퇴사사유, 기타기술),
                                            자격면허(발행일, 명칭, 발행처), 사회경험(기간, 장소, 내용)
                                        </p>
                                        <p>
                                            - 수집 및 이용목적 : 이력서 등록을 통한 입사지원 등 취업활동 서비스 제공,
                                            각종 맞춤형 취업서비스 제공
                                        </p>
                                        <p className="pad_t5 mar_b5">3) 채용정보 등록</p>
                                        <p className="mar_b5">
                                            담당자의 정보는 채용 및 결제확인 이외의 용도로 이용할 수 없으며, 신청하신
                                            서비스의 원활한 이용과 정보도용 및 허위정보 게재로 인한 피해를 방지하기 위해
                                            채용담당자의 개인정보를 확인하고 있습니다.
                                        </p>
                                        <p>
                                            - 필수항목 : 기본정보(사업장명, 대표자명), 결제정보(카드(카드사명,
                                            카드번호)), 담당자정보(담당자명, 이메일, 전화번호, 핸드폰)
                                        </p>
                                        <p>- 수집 및 이용목적 : 상담 및 문의처리, 채용동향 및 공지사항 전달</p>
                                        <p className="pad_t5 mar_b5">4) 온라인 상품 주문등록</p>
                                        <p>
                                            - 필수항목 : 주문정보(주문자명, 연락처, 이메일), 배송정보(수취인, 연락처,
                                            주소), 결제정보(카드(카드사명, 카드번호)), 휴대폰(휴대폰번호, 통신사정보),
                                            실시간계좌이체(은행명, 계좌번호)), 현금영수증 발행정보 및 수령자 정보
                                        </p>
                                        <p>- 수집 및 이용목적 : 주문 상품의 결제 및 환불, 배송 등</p>
                                        <p className="pad_t5 mar_b5">5) 온라인 세미나 신청등록</p>
                                        <p>
                                            - 필수항목 : 신청정보(신청자명, 회원구분, 치과의사구분, 근무처명, 주소,
                                            연락처, 핸드폰, 이메일, 이메일수신여부), 결제정보(카드(카드사명, 카드번호)),
                                            휴대폰(휴대폰번호, 통신사정보), 실시간계좌이체(은행명, 계좌번호)),
                                            현금영수증 발행정보 및 수령자 정보
                                        </p>
                                        <p>- 수집 및 이용목적 : 신청 상품의 결제 및 환불, 행사진행 등</p>
                                        <p className="pad_t5 mar_b5">6) 유료서비스 이용</p>
                                        <p>
                                            - 필수항목 : 결제정보(카드(카드사명, 카드번호)), 휴대폰(휴대폰번호,
                                            통신사정보), 실시간계좌이체(은행명, 계좌번호)), 현금영수증 발행정보 및
                                            수령자 정보
                                        </p>
                                        <p>- 수집 및 이용목적 : 유료서비스 구매 및 이용 시 요금 정산</p>
                                        <p className="pad_t5 mar_b5">
                                            결제정보는 결제대행업체에 저장하며, 결제내역 확인 및 상담처리를 위해 당사는
                                            최소한의 정보만 저장 및 관리하고 있습니다.
                                        </p>
                                        <p className="mar_b5">7) 서비스 이용에 따른 자동 수집 및 생성 정보</p>
                                        <p>- 항목 : 쿠키, 서비스이용기록(방문일시, IP, 불량이용기록), 광고 ID</p>
                                        <p>
                                            - 수집 및 이용목적 : 접속관리, 이용자별 사용환경 제공, 활동정보 파악, 이벤트
                                            및 프로모션 통계 확인
                                        </p>
                                        <p className="pad_t5 mar_b5">8) 본인인증</p>
                                        <p>
                                            - 항목 : 이름, 생년월일, 성별, 중복가입확인정보(DI), 암호화된 동일인
                                            식별정보(CI), 휴대폰번호, 외국인 구분 값
                                        </p>
                                        <p>- 수집 및 이용목적 : 이용자 식별 및 본인여부 확인, 회원정보 연동</p>
                                        <p className="pad_t5 mar_b5">나. 개인정보 수집방법</p>
                                        <p>
                                            사이트(덴탈잡, 덴탈비타민, 덴탈세미나,DVmall), 서비스 이용, 이벤트 응모,
                                            팩스, 우편, 전화, 고객센터 문의하기
                                        </p>
                                        <p className="pad_t5 mar_b5">
                                            <strong>
                                                귀하께서는 사이트가 위와 같이 수집하는 개인정보에 대해 동의하지 않거나
                                                개인정보를 기재하지 않음으로써 거부할 수 있습니다. 다만, 이때 회원에게
                                                제공되는 서비스가 제한될 수 있습니다.
                                            </strong>
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>2. 개인정보 보유 및 이용기간</strong>
                                        </p>
                                        <p className="mar_b5">
                                            "사이트"는 회원가입일로부터 서비스를 제공하는 기간 동안에 한하여 이용자의
                                            개인정보를 보유 및 이용하게 됩니다. 회원탈퇴를 요청하거나 개인정보의 수집 및
                                            이용에 대한 동의를 철회하는 경우, 수집 및 이용목적이 달성되거나 이용기간이
                                            종료한 경우 개인정보를 지체 없이 파기합니다.
                                        </p>
                                        <p className="mar_b5">
                                            단, 다음의 경우에 대해서는 각각 명시한 이유와 기간 동안 보존합니다.
                                        </p>
                                        <p className="mar_b5">
                                            1) 상법 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 법령에서 규정한
                                            보존기간 동안 거래내역과 최소한의 기본정보를 보유합니다. 이 경우 사이트는
                                            보관하는 정보를 그 보관의 목적으로만 이용합니다.
                                        </p>
                                        <p>① 계약 또는 청약철회 등에 관한 기록: 5년</p>
                                        <p>② 대금결제 및 재화 등의 공급에 관한 기록: 5년</p>
                                        <p>③ 소비자의 불만 또는 분쟁처리에 관한 기록: 3년</p>
                                        <p>④ 부정이용 등에 관한 기록: 5년</p>
                                        <p>⑤ 웹사이트 방문기록(로그인 기록, 접속기록): 1년</p>
                                        <p className="pad_t5">
                                            2) 보유기간을 미리 공지하고 그 보유기간이 경과하지 아니한 경우와 개별적으로
                                            동의를 받은 경우에는 약정한 기간 동안 보유합니다.
                                        </p>
                                        <p>3) 개인정보 유효기간제(휴면계정 정책)</p>
                                        <p>
                                            회사는 정보통신망법 '개인정보 유효기간제' 규정의 폐지에 따라 기존 휴면
                                            계정(1년 이상 장기 미접속자) 전환 제도를 종료하였으며, 이용자가 직접 회원
                                            탈퇴를 요청하거나 동의를 철회할 때까지 안전하게 개인정보를 보관합니다. 계정
                                            정리를 원하는 경우 마이페이지->회원탈퇴를 통하여 언제든지 즉각적인 파기
                                            조치가 가능합니다.
                                        </p>
                                        <br />
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="title-terms">
                                    <label className="reg__label">
                                        <input
                                            type="checkbox"
                                            name="accept-5"
                                            defaultValue="accept"
                                            className="reg__checkbox"
                                            checked={checkboxes['accept-5']}
                                            onChange={handleCheckboxChange}
                                        />
                                    </label>
                                    <p>
                                        <span className="flex">
                                            <span>이벤트 등 프로모션 안내 정보 수신 - 이메일/SMS외</span>
                                        </span>
                                        <strong>(선택)</strong>
                                        <span className="view-more-btn" onClick={() => toggleTermsContent(4)}>
                                            <span className="star">※</span>
                                            <span>이벤트 등 프로모션 안내 정보 수신 전문보기</span>
                                        </span>
                                    </p>
                                </div>
                                <div className={`content-terms ${activeTerms[4] ? 'active' : ''}`}>
                                    <div className="contracts">
                                        <p>이벤트 등 프로모션 안내 정보 수신</p>
                                        <p>1. 수집항목: 이메일 수신동의, SMS/MMS 수신동의 </p>
                                        <p>
                                            2. 수집ㆍ이용목적: 신규 서비스 안내, 설문, 이벤트 관련 정보 및 참여기회
                                            제공, 광고 및 마케팅 정보 제공
                                        </p>
                                        <p>3. 보유 및 이용기간: 회원탈퇴 시 지체없이 파기</p>
                                        <p>※ 회원가입시 선택적으로 동의할 수 있습니다.</p>
                                        <p>※ 선택사항에 동의하지 않으셔도 회원가입은 계속 진행할 수 있습니다.</p>
                                        <p>
                                            ※ 선택사항에 미동의시 서비스 안내, 설문, 이벤트 관련 정보 및 참여기회등이
                                            제한될 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="title-terms">
                                    <p>
                                        <span className="flex pl28">
                                            <span>DV포인트 이용안내</span>
                                        </span>
                                        <span className="view-more-btn" onClick={() => toggleTermsContent(5)}>
                                            <span className="star">※</span>
                                            <span>DV포인트 이용안내 전문보기</span>
                                        </span>
                                    </p>
                                </div>
                                <div className={`content-terms ${activeTerms[5] ? 'active' : ''}`}>
                                    <div className="privacys">
                                        <p className="mar_b10">
                                            <b>1. 적용 대상</b>
                                        </p>
                                        <p className="mar_b5">
                                            덴탈비타민 및 덴탈세미나, 덴탈잡의 치과의사 회원, 치과 기공사 회원에 한해
                                            포인트 적립됩니다. 단 치과 기공사 회원은 골드 CMS 적립을 통한 결제 시에만
                                            적립됩니다.
                                        </p>
                                        <p className="mar_b10">
                                            <b>2. 적립</b>
                                        </p>
                                        <p>
                                            - 덴탈비타민 및 협력사의 개별 정책에 따라 미리 공지되는 상품구매, 서비스
                                            구매, 이벤트 참여 등을 통하여 이용자에게 포인트 적립 기회를 부여/적립됩니다.
                                        </p>
                                        <p>
                                            - 적립률 및 기준은 당사와 제휴사의 내부 방침에 따라 임의로 변경될 수
                                            있습니다.
                                        </p>
                                        <p className="mar_b10">
                                            <b>3. 사용</b>
                                        </p>
                                        <p>
                                            - DV Point는 1 포인트부터 사용할 수 있으며 1포인트는 1원과 동일한 가치로
                                            사용하실 수 있습니다.
                                        </p>
                                        <p>
                                            - 적립된 DV Point는 포인트 운영 정책에 따라 해당 제휴사에서 사용할 수
                                            있습니다.
                                        </p>
                                        <p>
                                            - 회원은 포인트를 타인에게 양도하거나 대여 또는 담보의 목적으로 이용할 수
                                            없습니다.
                                        </p>
                                        <p className="mar_b10">
                                            <b>4. 유효기간 </b>
                                        </p>
                                        <p>
                                            - 적립된 포인트의 유효기간은 적립일로부터 5년이며, 유효기간 내에 사용되지
                                            않은 포인트는 기간 만료 시 자동 소멸됩니다.
                                        </p>
                                        <p>- 2018년 8월 1일 이전 적립 포인트 : 2018년 8월 1일부터 5년</p>
                                        <p>- 2018년 8월 1일 이후 적립 포인트 : 적립일로부터 5년</p>
                                        <p>
                                            - 적립된 포인트가 법률에 위반하여 적립되었거나, 부정한 방법에 의한 적립
                                            사실이 확인될 경우 포인트의 사용이 중지되거나, 소멸될 수 있습니다.
                                        </p>
                                        <p>
                                            - 적립된 포인트 사용 순서는 회원이 보유 중인 포인트 중 소멸 일자가 빠른
                                            포인트부터 우선적으로 차감 됩니다.
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="title-terms">
                                    <p>
                                        <span className="flex pl28">
                                            <span>개인정보 제3자 제공 및 위탁사항 안내</span>
                                        </span>
                                        <span className="view-more-btn" onClick={() => toggleTermsContent(6)}>
                                            <span className="star">※</span>
                                            <span>개인정보 제3자 제공 및 위탁사항 안내 전문보기</span>
                                        </span>
                                    </p>
                                </div>
                                <div className={`content-terms ${activeTerms[6] ? 'active' : ''}`}>
                                    <div className="privacys">
                                        <p className="mar_b10">
                                            <strong>1. 개인정보 제3자 제공</strong>
                                        </p>
                                        <p className="mar_b5">
                                            가. 사이트는 이용자들의 개인정보를 「개인정보의 수집·이용」에서 고지한 범위
                                            내에서 사용하며, 이용자의 사전 동의 없이 동 범위를 초과하여 이용하거나
                                            원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 아래의
                                            경우에는 예외로 합니다.
                                        </p>
                                        <p>- 이용자들이 사전에 공개 또는 제3자 제공에 동의한 경우</p>
                                        <p>
                                            - 법령의 규정에 의거하거나, 수사, 조사 목적으로 법령에 정해진 절차와 방법에
                                            따라 수사기관 및 감독당국의 요구가 있는 경우
                                        </p>
                                        <p>- 요금 정산을 위하여 필요한 경우</p>
                                        <p className="pad_t5 mar_b5">
                                            나. 그 밖에 개인정보 제3자 제공이 필요한 경우에는 이용자의 동의를 얻는 등
                                            적법한 절차를 통하여 제3자에게 개인정보를 제공할 수 있습니다. 사이트는
                                            이용자들의 거래 이행을 위하여 필요한 경우 이용자의 동의를 얻는 등 적법한
                                            절차를 통하여 아래와 같이 개인정보를 제공할 수 있습니다.
                                        </p>
                                        <p>- 제공하는 사이트 : 덴탈잡</p>
                                        <p>- 제공받는자 : ㈜DV파트너즈</p>
                                        <p>
                                            - 제공하는 항목 및 이용목적 : 1. 개인정보의 수집 및 이용현황에서 고지한 범위
                                        </p>
                                        <p>
                                            - 보유 및 이용기간 : 회원 탈퇴 시 혹은 서비스 제공기간 (관계법령의 규정에
                                            의하여 보존할 필요가 있는 경우 및 사전 동의를 득한 경우 해당 보유 기간) 종료
                                            시까지
                                        </p>
                                        <p className="mar_b5" />
                                        <p>- 제공하는 사이트 : 덴탈세미나, 덴탈비타민</p>
                                        <p>- 제공받는자 : ㈜신흥</p>
                                        <p>
                                            - 제공하는 항목 및 이용목적 : 1. 개인정보의 수집 및 이용현황에서 고지한 범위
                                        </p>
                                        <p>
                                            - 보유 및 이용기간 : 회원 탈퇴 시 혹은 서비스 제공기간 (관계법령의 규정에
                                            의하여 보존할 필요가 있는 경우 및 사전 동의를 득한 경우 해당 보유 기간) 종료
                                            시까지
                                        </p>
                                        <p className="mar_b5" />
                                        <p>- 제공하는 사이트 : 덴탈잡, 덴탈세미나, 덴탈비타민</p>
                                        <p>- 제공받는자 : ㈜디브이몰(DVmall)</p>
                                        <p>
                                            - 제공하는 항목 및 이용목적 : 1. 개인정보의 수집 및 이용현황에서 고지한
                                            회원가입, 채용등록정보
                                        </p>
                                        <p>
                                            - 보유 및 이용기간 : 회원 탈퇴 시 혹은 서비스 제공기간 (관계법령의 규정에
                                            의하여 보존할 필요가 있는 경우 및 사전 동의를 득한 경우 해당 보유 기간) 종료
                                            시까지
                                        </p>
                                        <p className="pad_t5 mar_b5">
                                            <strong>
                                                귀하께서는 개인정보의 제3자 제공에 대해, 동의하지 않을 수 있고 언제든지
                                                제3자 제공 동의를 철회할 수 있습니다. 다만, 제3자 제공에 기반한 관련된
                                                일부 서비스의 이용이 제한될 수 있습니다. (회원가입 서비스는 이용하실 수
                                                있습니다).
                                            </strong>
                                        </p>
                                        <br />
                                        <p className="mar_b10">
                                            <strong>2. 개인정보의 제공 및 처리위탁</strong>
                                        </p>
                                        <p className="mar_b5">
                                            "사이트"는 개인정보를 1. 개인정보의 수집 및 이용현황에서 고지한 범위 내에서
                                            사용하며, 이용자의 사전 동의 없이 동 범위를 초과하여 이용하지 않습니다.
                                        </p>
                                        <p className="mar_b5">가. 처리위탁</p>
                                        <p className="mar_b5">
                                            "사이트"는 서비스 향상을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계
                                            법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을
                                            규정하고 있습니다. 변동사항 발생 시 공지사항 또는 개인정보처리방침을 통해
                                            고지하도록 하겠습니다.
                                        </p>
                                        <p>- 위탁사이트 : 덴탈잡</p>
                                        <p>- 수탁업체 : ㈜DV파트너즈</p>
                                        <p>- 위탁업무 내용 : 고객센터 운영 및 상담, 컨텐츠 생성 및 제공</p>
                                        <p>- 개인정보 이용 기간 : 회원 탈퇴 시 혹은 위탁계약 종료 시까지</p>
                                        <p className="mar_b5" />
                                        <p>- 위탁사이트 : 덴탈세미나, 덴탈비타민</p>
                                        <p>- 수탁업체 : ㈜신흥</p>
                                        <p>- 위탁업무 내용 : 서비스 계약안내, 서비스이용계약체결, 정산</p>
                                        <p>- 개인정보 이용 기간 : 회원 탈퇴 시 혹은 위탁계약 종료 시까지</p>
                                        <p className="mar_b5" />
                                        <p>- 위탁사이트 : 덴탈잡, 덴탈세미나, 덴탈비타민</p>
                                        <p>- 수탁업체 : ㈜디브이몰(DVmall)</p>
                                        <p>- 위탁업무 내용 : 이용권 구매 및 이벤트 대행</p>
                                        <p>- 개인정보 이용 기간 : 회원 탈퇴 시 혹은 위탁계약 종료 시까지</p>
                                        <p className="mar_b5" />
                                        <p>- 위탁사이트 : 덴탈잡, 덴탈세미나, 덴탈비타민</p>
                                        <p>- 수탁업체 : ㈜케이지이니시스</p>
                                        <p>- 위탁업무 내용 : 결제처리(신용카드, 실시간계좌이체, 무통장입금)</p>
                                        <p>- 개인정보 이용 기간 : 관계법령에 따른 보관 기한까지</p>
                                        <p className="mar_b5" />
                                        <p>- 위탁사이트 : 덴탈세미나, 덴탈비타민</p>
                                        <p>- 수탁업체 : CJ대한통운㈜</p>
                                        <p>- 위탁업무 내용 : 실물에 대한 통합 택배서비스</p>
                                        <p>- 개인정보 이용 기간 : 회원 탈퇴 시 혹은 위탁계약 종료 시까지</p>
                                        <p className="mar_b5" />
                                        <p>- 위탁사이트 : 덴탈잡, 덴탈세미나, 덴탈비타민</p>
                                        <p>- 수탁업체 : ㈜페이투스</p>
                                        <p>- 위탁업무 내용 : 이벤트 경품(모바일기프트) 발송 대행</p>
                                        <p>- 개인정보 이용 기간 : 회원 탈퇴 시 혹은 위탁계약 종료 시까지</p>
                                        <p className="pad_t5 mar_b5">
                                            나. 다음의 경우에는 합당한 절차를 통한 이용자의 동의를 얻어 개인정보를 제공
                                            또는 이용할 수 있습니다.
                                        </p>
                                        <p>
                                            1) 매각, 인수합병: 서비스 제공자의 권리, 의무가 승계 또는 이전되는 경우 이를
                                            반드시 사전에 고지하며 이용자의 개인정보에 대한 동의철회의 선택권을
                                            부여합니다
                                        </p>
                                        <p>2) 다만, 아래의 경우에는 예외로 합니다.</p>
                                        <p>
                                            - 법령의 규정에 의거하거나, 수사, 조사 목적으로 법령에 정해진 절차와 방법에
                                            따라 수사기관 및 감독당국의 요구가 있는 경우
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        {!statusIntegrated && (
                            <div className="mmb-typ">
                                <input type="radio" name="mmbTyp" value="C" id="mmbTypDental" />
                                <label
                                    htmlFor="mmbTypDental"
                                    onClick={() => {
                                        handleSubmit('C');
                                    }}
                                >
                                    치과회원 가입
                                </label>
                                <input type="radio" name="mmbTyp" value="P" id="mmbTypPersonal" />
                                <label
                                    className="green"
                                    htmlFor="mmbTypPersonal"
                                    onClick={() => {
                                        handleSubmit('P');
                                    }}
                                >
                                    개인회원 가입
                                </label>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {/* End Content Register */}
            {statusIntegrated && (
                <div className="button-group">
                    <button
                        className="button button-blue border-radius-10 border-1-ddd"
                        onClick={() => handleSubmit(userData.memberGbn)}
                    >
                        약관동의 및 회원정보 수정
                    </button>
                </div>
            )}
        </div>
    );
};

export default PADAB010;
